
import React from "react";
import moment from "moment";
import { message } from "antd";
import PaginationBase from "../../../common/base/PaginationBase";
import global from "../../../common/utility/global";
import auth from "../../../common/utility/auth";
import dialog from "../../../common/utility/dialog";
import { PAGINATION, FILTER } from "../../../common/types/paginationType";
import { SOLES, DOLARES_AMERICANOS } from "../../../common/types/monedaType";
import { lst_pendiente_pagos, CANCELADO, PENDIENTE } from "../../../common/types/pendientePagoType";
import { lst_tipo_impuesto } from "../../../common/types/impuestoType";
import { IMPUESTO_PROMOCION_MUNICIPAL } from "../../../common/types/parametroType";
import { lst_tipo_afectacion } from "../../../common/types/tipoAfectacion";

import { APROBADO_COMPRA } from "../../../common/types/compraEstadoType";
import { APROBADO } from '../../../common/types/ordenCompraEstadoType';
import proveedorService from "../../../service/administracion/proveedorService";
import tipoComprobanteService from "../../../service/administracion/tipoComprobanteService";
import compraService from "../../../service/logistica/compraService";
import movimientoService from "../../../service/logistica/movimientoService";
import monedaService from "../../../service/administracion/monedaService";
import listaPrecioService from "../../../service/administracion/listaPrecioService";
import tipoCambioDiarioService from "../../../service/administracion/tipoCambioDiarioService";
import establecimientoService from "../../../service/administracion/establecimientoService";
import vendedorService from "../../../service/administracion/vendedorService";
import detraccionService from "../../../service/administracion/detraccionService";
import almacenService from "../../../service/administracion/almacenService";
import productoService from "../../../service/administracion/productoService";
import ordenCompraService from "../../../service/logistica/ordenCompraService";
import ordenServiceService from "../../../service/logistica/ordenServicioService";
import proyectoService from '../../../service/administracion/proyectoService';
import hubService from '../../../service/hub/hubService';
import empresaService from '../../../service/administracion/empresaService';

import padronReducidoService from "../../../service/integracion/padronReducidoService";
import formaPagoService from '../../../service/administracion/formaPagoService';
import metodoPagoservice from '../../../service/administracion/metodoPagoService';
import cuentaService from '../../../service/administracion/cuentaService';
import { CONTADO, CREDITO } from '../../../common/types/formaPagoType';
import motivoNotaCreditoService from '../../../service/administracion/motivoNotaCreditoService';

import bancoService from '../../../service/administracion/bancoService';
import configuracionService from '../../../service/seguridad/usuarioConfiguracionService';
import {
  VENTA_PRECIO_UNITARIO_INCLUYE_IGV
} from "../../../common/types/parametroType";

import Header from "../../../components/Header";
import Filters from "./Filters";
import ResultList from "./ResultList";
import FormModal from "./FormModal";
import ViewModal from "./ViewModal";
import Vincular from "./VincularModal";
import DetalleIngreso from './DetalleIngreso';

import BuscarProductoModal from "./BuscarProductoModal";
import EditarNombreProductoModal from "./EditarNombreProductoModal";
import ImportarOrdenCompraModal from "./ImportarOrdenCompraModal";
import ImportarModalOC from "./ImportarModalOC";
import AgregarSerieModal from "./AgregarSerieModal";

import ImportarCompra from "./ImportarCompra";

import { LOGISTICA_ORDEN_COMPRA, LOGISTICA_ORDEN_SERVICIO, LOGISTICA_COMPRA } from '../../../common/types/referenciaOrigenType';
import { LOGISTICA } from '../../../common/types/moduloType';
import { APROBAR_CO, } from '../../../common/types/configuracionType';

var formValuesOC = {
  detalleProductos: [],
  listaCompraDetalle: [],
  listaCompraReferencia: [],
  productos: [],
  idOrdenCompra: 0
}
export const lista_tipo = [{ id: 1, nombre: "SERVICIO" }, { id: 2, nombre: "BIENES" }, { id: APROBADO, nombre: "ACTIVOS" }]


export default class Index extends PaginationBase {
  constructor(props) {
    super(props);
    this.props.onSetBreadcrumb();
    this.state = {
      loadingSource: true,
      loadingExcel: false,
      loadingPdf: false,
      loadingPrint: false,
      searchProductVisible: false,
      importarOCVisible: false,
      importarCompraVisible: false,
      importarOSVisible: false,
      agregarSerieVisible: false,
      isPendiente: false,
      visibleVincular: false,
      isPendienteSi: true,
      loadingVincular: false,
      filter: {
        idProveedor: 0,
        proveedor: "",
        idTipoComprobante: 0,
        fechaInicioStr: global.fetchCurrentDateStr(true),
        fechaFinStr: global.fetchCurrentDateStr(),
        serie: "",
        documento: "",
        idProyecto: 0,
        tipoReporte: 1,
        ...FILTER,
      },
      editarNombreProductoFormValues: {
        id: "",
        nombre: "",
      },
      searchProductFormValues: {
        nombre: "",
        dataSource: [],
        selectedRowKeys: [],
      },
      importarOrdenCompraModal: {
        nombre: '',
        dataSource: [],
        dataSourceDetalle: [],
        detalleProductos: []
      },
      importarCotizacionFormValues: {
        nombre: "",
        dataSource: [],
        selectedRowKeys: [],
      },

      importarCompraModal: {
        nombre: '',
        dataSource: [],
        dataSourceDetalle: [],
        detalleProductos: []
      },

      agregarSerieModal: {
        serie: '',
        idProducto: 0,
        listaCompraDetalleSerie: []
      },

      direcciones: [],
      proveedores: [],
      almacenes: [],
      monedas: [],
      establecimientos: [],
      almacenAll: [],
      tiposComprobanteAll: [],
      TipoAlmacen: [],
      motivos: [],
      formasPago: [],
      configuraciones: [],
      proveedoresAutoComplete: [],
      tiposComprobante: [],
      proyectos: [],
      listaCuentas: [],
      clasificacion: [],
      clasificacionAll: [],
      pendientePago: lst_pendiente_pagos,
      pagination: PAGINATION,
      visible: false,
      formValues: this.fetchEmptyFormValues(),
      viewVisible: false,
      viewFormValues: {},
      company: {},
      viewVincular: {},
      cuotasVinculo: [],
      percepciones: [
        {
          "id": 1,
          "nombre": "Percepción Venta Interna",
          "codigoSunat": "01",
          "porcentaje": 2,
          "label": "01 Percepción Venta Interna"
        },
        {
          "id": 2,
          "nombre": "Percepción a la adquisición de combustible",
          "codigoSunat": "02",
          "porcentaje": 1,
          "label": "02 Percepción a la adquisición de combustible"
        },
        {
          "id": 3,
          "nombre": "Percepción realizada al agente de percepción con tasa especial",
          "codigoSunat": "03",
          "porcentaje": 0.5,
          "label": "03 Percepción realizada al agente de percepción con tasa especial"
        },
        {
          "id": 4,
          "nombre": "Bienes Importados",
          "codigoSunat": "04",
          "porcentaje": 10,
          "label": "04 Bienes Importados"
        },
        {
          "id": 5,
          "nombre": "Bienes Importados",
          "codigoSunat": "05",
          "porcentaje": 5,
          "label": "05 Bienes Importados"
        },
        {
          "id": 6,
          "nombre": "Bienes Importados",
          "codigoSunat": "06",
          "porcentaje": 3.5,
          "label": "06 Bienes Importados"
        }
      ]
    };
  }

  fetchEmptyFormValues = () => {
    return {
      id: 0,
      idProveedor: 0,
      IdEstablecimientoProveedor: 0,
      idTipoComprobante: 0,
      idMoneda: SOLES,
      idEstablecimiento: 0,
      idAlmacen: 0,
      idProyecto: 0,
      fechaStr: global.fetchCurrentDateStr(),
      fechaVencimientoStr: global.fetchCurrentDateStr(),
      fechaRecepcionStr: global.fetchCurrentDateStr(),
      fechaDocumentoStr: global.fetchCurrentDateStr(),
      serie: "",
      documento: "",
      idFormaPago: CONTADO,
      idPendiente: 1,
      idDetraccion: 0,
      idUsuarioRegistro: auth.user().id,
      diasVencimiento: 0,
      tipoCambio: 0,
      observacion: "",
      flagExportacion: false,
      flagPercepcion: false,
      flagRetencion: false,
      flagDetraccion: false,
      listaCompraDetalle: [],
      listaCompraReferencia: [],
      listaComprobanteCuota: [],
      listaComprobanteMetodoPago: [],
      listaCompraDetalleSerie: [],
      metodosPagos: [],
      listaBanco: [],
      clasificacion: [],
      otroImpuesto: 1,//auth.user().parametros.filter(m => m.abreviatura === IMPUESTO_PROMOCION_MUNICIPAL)[0].valor === "1" ? 2 : 1,
      importeRetencion: 0,
      totalRetencion: 0,
      porcentajeRetencion: auth.user().porcentajeRetencion,

      sumaExonerada: 0,
      sumaInafecta: 0,
      sumaGratuita: 0,
      /*********************/
      sumaTotalDetalle: 0,
      sumaImporteDescuento: 0,
      sumaSubTotal: 0,
      sumaIgv: 0,
      sumaIsc: 0,
      sumaTotal: 0,
      porcentajeDetraccion: 0,
      importeDetraccion: 0,
      totalDetraccion: 0,
      porcentajePercepcion: 0,
      porcentajeDescuentoGlobal: 0,
      importeDescuentoGlobal: 0,
      importePercepcion: 0,
      totalPercepcion: 0,
      almacenLoading: false,
      proveedorLoading: false,
      flagDescuentoGlobal: false,
      activeKey: "1",
      documentoCliente: "",
      monedas: [],
      establecimientos: [],
      almacenes: [],
      proveedores: [],
      direcciones: [],
      tiposComprobante: [],
      tiposComprobanteAll: [],
      detracciones: [],
      detalleProductos: [],
      // conceptos: [],
      percepciones: [],

      proyectos: [],
      formasPago: [],
      cuentas: [],
      pendientePago: [],
      idMotivoNotaCredito: 0,
      idTipo: 2,
      idTipoAlmacen: 0,
      idClasificacion: 1,
      Tipo: [],
      TipoAlmacen: [],
      Motivos: [],
      Tipoimpuesto: lst_tipo_impuesto,
    };
  };

  handleSearchAutocomplete = (value) => {
    const result = this.state.proveedores
      .filter((item) => {
        return item.nombre.toUpperCase().match(value.toUpperCase());
      })
      .slice(0, 75);
    this.setState({ proveedoresAutoComplete: result });
  };

  handleChangeAutocomplete = (value) => {
    this.setState({
      filter: {
        ...this.state.filter,
        idProveedor: value.key,
      },
    });
  };

  handleClearAutocomplete = () => {
    this.setState({
      filter: {
        ...this.state.filter,
        idProveedor: 0,
        idTipoComprobante: 0,
        fechaInicioStr: global.fetchCurrentDateStr(true),
        fechaFinStr: global.fetchCurrentDateStr(),
        serie: "",
        documento: "",
        idProyecto: 0,
      },
    });
  };

  handleKeyUpInput = (e) => {
    e.preventDefault();
    if (e.keyCode === 13) {
      const filter = { ...this.state.filter, ...FILTER };
      this._handlePagination(filter);
    }
  };

  handleChange = (property, value) => {
    const filter = { ...this.state.filter, [property]: value };
    this.setState({ filter });
    if (property = 'tipoReporte') {
      this._handlePagination(filter)
    }
  };

  handleClearFilters = async () => {
    var filter = {
      serie: "",
      documento: "",
      proveedor: "",
      idProveedor: 0,
      idTipoComprobante: 0,
      fechaInicioStr: global.fetchCurrentDateStr(true),
      fechaFinStr: global.fetchCurrentDateStr(),
      tipoReporte: 1,
      ...FILTER,
    };
    this.setState({ filter });
    this._handlePagination(filter);
  };

  handleChangeTab = (key, onSetFieldsValue) => {
    if (key == "2") {
      onSetFieldsValue({
        flagReferencia: true,
      });
    }
    if (key == "3") { // Cuotas
      onSetFieldsValue({
        flagCuota: true
      })
    }

    if (key == "4") { // Metodo de Pago
      onSetFieldsValue({
        flagMetodoPago: true
      })
    }

    this.setState({
      formValues: {
        ...this.state.formValues,
        activeKey: key,
      },
    });
  };

  handleNew = async () => {

    var params = auth.user().parametros;

    var listasComprobantes = [];
    this.state.tiposComprobante.forEach(element => {
      var item = element;
      if (["01", "03", "07", "09"].includes(element.codigoSunat)) {
        listasComprobantes.push(item);
      }
    });
    var flagPrecioIncluyeIGV = params.filter((m) => m.abreviatura === VENTA_PRECIO_UNITARIO_INCLUYE_IGV)[0].valor === "1" ? true : false;

    this.setState({ loadingNew: true });
    var formValues = this.fetchEmptyFormValues();
    formValues.flagPrecioIncluyeIGV = flagPrecioIncluyeIGV;
    formValues.monedas = this.state.monedas;
    formValues.otroImpuesto = this.state.company.idTipoImpuesto;

    formValues.tipoCambio = this.fetchTipoCambio(DOLARES_AMERICANOS);
    formValues.establecimientos = this.state.establecimientos;
    formValues.tiposComprobanteAll = this.state.tiposComprobante;
    formValues.tiposComprobante = listasComprobantes;
    formValues.detracciones = this.state.detracciones;
    formValues.proveedores = this.state.proveedores;
    formValues.formasPago = this.state.formasPago;
    formValues.metodosPagos = this.state.metodosPagos;
    formValues.cuentas = this.state.cuentas;
    formValues.listaBanco = this.state.listaBanco;
    formValues.TipoAlmacen = this.state.TipoAlmacen;
    formValues.Motivos = this.state.motivos;
    formValues.Tipo = lista_tipo;
    formValues.pendientePago = this.state.pendientePago;
    formValues.clasificacion = this.state.clasificacion;
    formValues.proyectos = this.state.proyectos;
    formValues.percepciones = this.state.percepciones;
    formValues.tipoAfectacion = lst_tipo_afectacion;

    this.setState({
      loadingNew: false,
      visible: true,
      listaCuentas: this.state.cuentas,
      formValues,
    });
  };

  fetchTipoCambio = (idMoneda, tiposCambioDiario) => {
    const filter = (tiposCambioDiario
      ? tiposCambioDiario
      : this.state.tiposCambioDiario
    ).filter((m) => m.idMoneda === idMoneda);
    if (filter.length > 0) return parseFloat(filter[0].compraSunat).toFixed(3);
    else return "0.000";
  };

  handleChangeForm = async (property, value, form) => {
    const listasComprobantes = [];
    if (property === "fechaStr") {
      const fecha = moment(value, "DD/MM/YYYY");
      const fechaVencimiento = moment(
        form.getFieldValue("fechaVencimientoStr"),
        "DD/MM/YYYY"
      );
      const tiposCambioDiario = await tipoCambioDiarioService.listarPorFecha(
        value
      );

      form.setFieldsValue({
        tipoCambio: this.fetchTipoCambio(DOLARES_AMERICANOS, tiposCambioDiario),
        diasVencimiento: fechaVencimiento.diff(fecha, "days").toString(),
      });
    }

    if (property === "idMoneda") {
      const listasPrecio = this.state.listasPrecio.filter(
        (m) => m.idMoneda === value
      );
      this.setState({
        formValues: {
          ...this.state.formValues,
          idListaPrecio: undefined,
          listasPrecio: listasPrecio ? listasPrecio : [],
        },
      });
    }

    if (property === "idProveedor") {
      const direcciones = await establecimientoService.listarPorIdEntidad(
        value
      );
      this.setState(
        {
          formValues: {
            ...this.state.formValues,
            direcciones: direcciones ? direcciones : [],
          },
        },
        () => {
          form.setFieldsValue({
            idEstablecimientoProveedor: {
              key: direcciones.length > 0 ? direcciones[0].id : undefined,
            },
          });
        }
      );
    }

    if (property === "direcciones-clear") {
      this.setState({
        formValues: {
          ...this.state.formValues,
          idProveedor: undefined,
          idEstablecimientoProveedor: undefined,
          documentoProveedor: "",
          direcciones: [],
        },
      });
    }

    if (property === "idEstablecimiento") {
      this.setState({
        formValues: { ...this.state.formValues, almacenLoading: true },
      });
      const almacenes = await almacenService.listarPorIdEstablecimiento(value);
      this.setState({
        formValues: {
          ...this.state.formValues,
          almacenLoading: false,
          almacenes: almacenes ? almacenes : [],
        },
        almacenAll: almacenes ? almacenes : []

      });
      form.setFieldsValue({
        idAlmacen: undefined,
        idTipoAlmacen: undefined
      });
    }

    if (property === "idTipoAlmacen") {
      debugger
      this.setState({ formValues: { ...this.state.formValues, almacenLoading: true } });
      const almacenes = this.state.almacenAll.filter(e => e.idTipoAlmacen == value);

      this.setState({
        formValues: {
          ...this.state.formValues,
          almacenLoading: false,
          almacenes: almacenes ? almacenes : []
        }
      });

      form.setFieldsValue({
        idAlmacen: undefined
      });
    }

    if (property === "idClasificacion") {

      debugger
      if (value == 4) {
        this.state.tiposComprobante.forEach(element => {
          var item = element;
          if (element.codigoSunat == "01" || element.codigoSunat == "03" || element.codigoSunat == "05") {
            listasComprobantes.push(item);
          }
        });

        this.setState({
          formValues: {
            ...this.state.formValues,
            tiposComprobante: listasComprobantes ? listasComprobantes : []
          },
        });
      }

      if (value == 5) {
        this.state.tiposComprobante.forEach(element => {
          var item = element;
          if (element.codigoSunat == "01" || element.codigoSunat == "03" || element.codigoSunat == "14") {
            listasComprobantes.push(item);
          }
        });

        this.setState({
          formValues: {
            ...this.state.formValues,
            tiposComprobante: listasComprobantes ? listasComprobantes : []
          },
        });
      }




      form.setFieldsValue({
        idTipoComprobante: undefined,
      });

    }


    if (property === "idTipo") {
      debugger

      if (this.state.formValues.listaCompraDetalle.length > 0) {

        dialog.confirm("Al cambiar el Tipo se eliminara el detalle \n ¿Esta seguro de realizar la acción?", () => {

          this.setState({
            formValues: {
              ...this.state.formValues,
              listaCompraDetalle: [],
              idOrdenCompra: 0,
              listaCompraReferencia: [],
              idTipo: value,
              idTipoComprobante: undefined,
              clasificacion: this.state.clasificacionAll.filter(item => item.codigo == value)

            }
          });

          form.setFieldsValue({
            sumaIsc: 0,
            sumaTotal: 0,
            sumaSubTotal: 0,
            sumaIgv: 0,
            sumaTotalDetalle: 0,
            idClasificacion: undefined,
            idTipoComprobante: undefined,

          });

        }, () => {

          this.setState({
            formValues: {
              ...this.state.formValues,

            }
          });

          form.setFieldsValue({
            idTipo: { key: this.state.formValues.idTipo },
          });

        }


        );


      }
      else {


        this.setState({
          formValues: {
            ...this.state.formValues,
            listaCompraDetalle: [],
            idOrdenCompra: 0,
            idTipoComprobante: 0,
            listaCompraReferencia: [],
            listaComprobanteCuota: [],

          }
        });

        if (value == 1) {

          this.state.tiposComprobante.forEach(element => {
            var item = element;
            if (element.codigoSunat == "01" || element.codigoSunat == "03" || element.codigoSunat == "14") {
              listasComprobantes.push(item);
            }
          });

        }
        if (value == 2) {

          this.state.tiposComprobante.forEach(element => {
            var item = element;
            if (element.codigoSunat == "01" || element.codigoSunat == "03" || element.codigoSunat == "09") {
              listasComprobantes.push(item);
            }
          });

        }

        if (value == 3) {
          this.state.tiposComprobante.forEach(element => {
            var item = element;
            if (element.codigoSunat == "01" || element.codigoSunat == "03") {
              listasComprobantes.push(item);
            }
          });

        }

        this.setState({
          formValues: {
            ...this.state.formValues,
            tiposComprobante: listasComprobantes ? listasComprobantes : [],
            clasificacion: this.state.clasificacionAll.filter(item => item.codigo == value),
            idTipo: value
          },
        });


        form.setFieldsValue({
          idClasificacion: undefined,
          detalleProductos: [],
          listaCompraReferencia: [],

        });

      }

    }

    if (property === "idTipoComprobante") {


      var data = form.getFieldValue(property);

      if (this.state.formValues.listaCompraDetalle.length > 0) {

        dialog.confirm(
          <span>
            Al cambiar el tipo de comprobante se removera los productos agregados previamente.
            <br />
            <span>¿Deseas continuar?'</span>
          </span>,
          async () => {

            this.setState({
              formValues: {
                ...this.state.formValues,
                listaCompraDetalle: [],
                detalleProductos: [],
                listaComprobanteCuota: [],
                listaCompraReferencia: [],
              },
            });
            form.setFieldsValue({
              sumaTotalDetalle: 0,
              sumaImporteDescuento: 0,
              sumaSubTotal: 0,
              sumaIgv: 0,
              sumaIsc: 0,
              sumaTotal: 0,
              porcentajeDetraccion: 0,
              importeDetraccion: 0,
              totalDetraccion: 0,
              porcentajePercepcion: 0,
              importePercepcion: 0,
              totalPercepcion: 0,
              detalleProductos: [],
              listaCompraDetalle: [],
            });
          },
          () =>
            form.setFieldsValue({
              [property]: data,
            })
        );
      } else {

        this.setState({
          formValues: {
            ...this.state.formValues,
            listaComprobanteMetodoPago: [],
            listaComprobanteCuota: [],
            idTipoComprobante: value,
            serie: value == 6 ? "3" : this.state.formValues.serie,
            idFormaPago: 1,
          },
        });

        form.setFieldsValue({
          idTipoComprobante: { key: value },
          serie: value == 6 ? "3" : this.state.formValues.serie,
          idFormaPago: { key: 1 }
        });

      }
    }

    if (property === "idFormaPago") {

      if (value == 2) { //CREDITO isPendienteSi

        const fecha = moment(form.getFieldValue("fechaStr"), "DD/MM/YYYY");
        const diasVencimiento = 1;
        form.setFieldsValue({
          fechaVencimientoStr: fecha.add("days", diasVencimiento),
        });

        this.setState({ isPendiente: true });
        this.setState({ isPendienteSi: true });

        this.setState({
          formValues: {
            ...this.state.formValues,
            idFormaPago: value,
            listaComprobanteMetodoPago: [],
            listaComprobanteCuota: [],
            idPendiente: 1, //PENDIENTE
            activeKey: "3"
          },
        });

        form.setFieldsValue({
          idFormaPago: { key: value },
          idPendiente: { key: 1 },
        });

      } else {
        // CONTADO
        const fecha = moment(form.getFieldValue("fechaStr"), "DD/MM/YYYY");
        const diasVencimiento = -0;
        form.setFieldsValue({
          fechaVencimientoStr: fecha.add("days", diasVencimiento),
        });
        this.setState({ isPendiente: false });
        this.setState({ isPendienteSi: false });

        this.setState({
          formValues: {
            ...this.state.formValues,
            idFormaPago: value,
            idPendiente: 1, //CANCELADO
            activeKey: "1",
            listaComprobanteCuota: [],

          },
        });

        form.setFieldsValue({
          idFormaPago: { key: value },
          idPendiente: { key: 1 },
        });

      }
    }

    if (property == "otroImpuesto") {
      var data = form.getFieldValue(property);

      if (this.state.formValues.listaCompraDetalle.length > 0) {

        dialog.confirm(
          <span>
            Al cambiar el tipo de impuesto se removera los productos agregados previamente.
            <br />
            <span>¿Deseas continuar?'</span>
          </span>,
          async () => {

            this.setState({
              formValues: {
                ...this.state.formValues,
                listaCompraDetalle: [],
                detalleProductos: [],
                listaComprobanteCuota: [],
                listaCompraReferencia: [],
              },
            });
            form.setFieldsValue({
              sumaTotalDetalle: 0,
              sumaImporteDescuento: 0,
              sumaSubTotal: 0,
              sumaIgv: 0,
              sumaIsc: 0,
              sumaTotal: 0,
              porcentajeDetraccion: 0,
              importeDetraccion: 0,
              totalDetraccion: 0,
              porcentajePercepcion: 0,
              importePercepcion: 0,
              totalPercepcion: 0,
              detalleProductos: [],
              listaCompraDetalle: [],
            });
          },
          () =>
            form.setFieldsValue({
              [property]: data,
            })
        );
      }
    }



    if (property === "idPendiente") {
      var listaComprobanteMetodoPago = this.state.formValues.listaComprobanteMetodoPago;

      debugger
      if (listaComprobanteMetodoPago.length > 0 && value == 1) { // PENDIENTE

        dialog.confirm("Al cambiar el estado se eliminaran el Método de Pago \n ¿Esta seguro de realizar la acción?", () => {

          this.setState({
            formValues: {
              ...this.state.formValues,
              listaComprobanteMetodoPago: [],
              idPendiente: value,

            }
          });

        }, () => {

          this.setState({
            formValues: {
              ...this.state.formValues,
              idPendiente: 2,

            }
          });

        }

        );


      } else {
        this.setState({
          formValues: {
            ...this.state.formValues,
            idPendiente: value,

          }
        });
      }
    }

  };

  handleClasificacion = (value, property) => {
    const listasComprobantes = [];

    if (property === "idClasificacion") {


      if (value == 1) {

        this.state.tiposComprobante.forEach(element => {
          var item = element;
          if (element.codigoSunat == "01" || element.codigoSunat == "03" || element.codigoSunat == "14") {
            listasComprobantes.push(item);
          }
        });

      }
      if (value == 2) {

        this.state.tiposComprobante.forEach(element => {
          var item = element;
          if (element.codigoSunat == "01" || element.codigoSunat == "03" || element.codigoSunat == "09") {
            listasComprobantes.push(item);
          }
        });

      }

      if (value == 3) {
        this.state.tiposComprobante.forEach(element => {
          var item = element;
          if (element.codigoSunat == "01" || element.codigoSunat == "03") {
            listasComprobantes.push(item);
          }
        });

      }
      if (value == 4) {

        this.state.tiposComprobante.forEach(element => {
          var item = element;
          if (element.codigoSunat == "01" || element.codigoSunat == "03" || element.codigoSunat == "05") {
            listasComprobantes.push(item);
          }
        });

      }

      if (value == 5) {

        this.state.tiposComprobante.forEach(element => {
          var item = element;
          if (element.codigoSunat == "01" || element.codigoSunat == "03" || element.codigoSunat == "14") {
            listasComprobantes.push(item);
          }
        });

      }




      return listasComprobantes;

    }

  }


  handleAgregarItem = (onSetFieldsValue, onGetFieldValue) => {
    debugger;
    var listaComprobanteDetalle = this.state.formValues.listaCompraDetalle;

    var item = {
      identifier: global.fetchUniqueCode(),
      idProducto: 1,
      idTipoProducto: 2, //Servicio
      codigo: null,
      nombre: 'Item ' + this.state.formValues.listaCompraDetalle.length,
      nombreUnidadMedida: 'UNIDAD (SERVICIOS)',
      flagAfecto: true,
      flagGratuito: false,
      flagISC: false,
      flagExonerado: false,
      isc: 0,
      precioUnitario: 0,
      valorUnitario: 0,
      cantidad: 0,
      totalDetalle: 0,
      numeroLote: '',
      porcentajeDescuento: 0,
      importeDescuento: 0,
      subTotal: 0,
      igv: 0,
      total: 0,
      listaCompraDetalleSerie: []
    };
    listaComprobanteDetalle.push(item);


    this.setState({
      formValues: {
        ...this.state.formValues,
        listaCompraDetalle: listaComprobanteDetalle
      },
    });


  };

  handleAgregarDetalle = (onSetFieldsValue, onGetFieldValue) => {
    debugger;
    this.setState(
      {
        onSetFieldsValue,
        onGetFieldValue,
      },
      () => {
        if (this.state.formValues.activeKey === "1")
          this.handleOpenSearchProductModal();

        const newLocal = "2";
        if (this.state.formValues.activeKey === newLocal)
          this.handleAddReferencia();

        const cuotas = "3";
        if (this.state.formValues.activeKey === cuotas)
          this.handleAddCuota();

        const formaPagos = "4";
        if (this.state.formValues.activeKey === formaPagos)
          this.handleAddMetodoPago();

      }
    );
  };

  handleOpenSearchProductModal = async () => {

    var tipoActividad = this.state.formValues.idTipo;

    var productos = await productoService.listar();
    var productos_filter = tipoActividad == 1 ? productos.filter(m => m.idTipoProducto != 1) : productos.filter(m => m.idTipoProducto === 1);
    this.setState({
      searchProductVisible: true,
      searchProductFormValues: {
        ...this.state.searchProductFormValues,
        dataSource: productos_filter,
        selectedRowKeys: this.state.formValues.listaCompraDetalle.map(function (v) {
          return v.idProducto;
        })
      },
      productos
    });
  };

  handleAddReferencia = () => {
    var listaCompraReferencia = this.state.formValues.listaCompraReferencia;

    listaCompraReferencia.push({
      identifier: global.fetchUniqueCode(),
      idReferencia: 0,
      idReferenciaOrigen: 0,
      idTipoComprobante: 0,
      serie: "",
      documento: "",
      flagInterno: false,
    });

    this.setState({
      formValues: {
        ...this.state.formValues,
        listaCompraReferencia: listaCompraReferencia,
        tiposComprobanteAll: this.state.tiposComprobante,

      },
    });
  };


  handleAddCuota = () => {
    const currentDate = moment().add(1, 'days');

    var intDay = 1
    var listaComprobanteCuota = this.state.formValues.listaComprobanteCuota;

    var nextMonthDate = currentDate.clone().add(listaComprobanteCuota.length, 'months');

    if (listaComprobanteCuota.length == 0) {

      listaComprobanteCuota.push({
        identifier: global.fetchUniqueCode(),
        correlativo: listaComprobanteCuota.length + 1,
        fechaVencimiento: nextMonthDate.format('DD-MM-YYYY'),
        montoCuota: 0,
        estado: "PENDIENTE"
      });

    } else {

      listaComprobanteCuota.push({
        identifier: global.fetchUniqueCode(),
        correlativo: listaComprobanteCuota.length + 1,
        fechaVencimiento: nextMonthDate.format('DD-MM-YYYY'),
        montoCuota: 0,
        estado: "PENDIENTE"
      });

    }

    this.setState({
      formValues: {
        ...this.state.formValues,
        listaComprobanteCuota: listaComprobanteCuota,

      }
    });
  };

  handleRemoverCuota = (item) => {

    var listaComprobanteCuota = this.state.formValues.listaComprobanteCuota.filter(m => m.identifier !== item.identifier);
    var newListaComprobanteCuota = [];
    var contador = 1;
    listaComprobanteCuota.forEach(element => {
      var cuota = element;
      cuota.correlativo = contador;
      newListaComprobanteCuota.push(cuota);
      contador += 1;
    });

    this.setState({
      formValues: {
        ...this.state.formValues,
        listaComprobanteCuota: newListaComprobanteCuota
      }
    });
  };

  handleSelectProduct = (selected, rows) => {
    debugger;
    var listaCompraDetalle = this.state.formValues.listaCompraDetalle;
    rows.forEach(row => {
      var filter = this.state.formValues.listaCompraDetalle.filter(m => { return m.idProducto === row.id; });
      if (filter.length === 0) {

        var item = {
          identifier: global.fetchUniqueCode(),
          idProducto: row.id,
          idTipoProducto: row.idTipoProducto,
          codigo: row.codigoReferencia,
          codigoBarra: row.codigoBarra,
          nombre: row.nombre,
          nombreUnidadMedida: row.nombreUnidadMedida,
          flagAfecto: row.flagIGVAfecto,
          flagGratuito: row.flagGratuito,
          flagISC: row.flagISC,
          flagExonerado: row.flagExonerado,
          isc: 0,
          flagVencimiento: row.flagVencimiento,
          flagAplicarSerie: row.flagAplicarSerie,
          fechaVencimientoStr: row.flagVencimiento ? global.fetchCurrentDateStr() : null,
          fechaProduccionStr: global.fetchCurrentDateStr(),
          precioUnitario: 0,
          valorUnitario: 0,
          precioUnitarioSinIGV: 0,
          cantidad: 0,
          totalDetalle: 0,
          numeroLote: '',
          porcentajeDescuento: 0,
          importeDescuento: 0,
          subTotal: 0,
          igv: 0,
          total: 0,
          qwer: 0,
          idImpuesto: row.idImpuesto,
          listaCompraDetalleSerie: []
        };
        listaCompraDetalle.push(item)
      }
    });

    listaCompraDetalle = listaCompraDetalle.filter(m => selected.filter(f => f === m.idProducto).length);

    this.setState({
      formValues: {
        ...this.state.formValues,
        listaCompraDetalle: listaCompraDetalle,
        detalleProductos: listaCompraDetalle
      },
      searchProductFormValues: {
        ...this.state.searchProductFormValues,
        selectedRowKeys: selected
      }
    });


  };

  onCalculateMetodoPago = (totalCompra) => {

    var listaComprobanteMetodoPago = this.state.formValues.listaComprobanteMetodoPago;

    if (listaComprobanteMetodoPago.length == 1) {
      var newPago = [];

      listaComprobanteMetodoPago.forEach((key) => {
        newPago.push({
          identifier: key.identifier,
          fechaPago: key.fechaPago,
          idMetodoPago: key.idMetodoPago, //efectivo
          idCuenta: key.idCuenta,
          referencia: key.referencia,
          montoPago: totalCompra
        });

      });

      this.setState({
        formValues: {
          ...this.state.formValues,
          listaComprobanteMetodoPago: newPago
        }
      });

    }

  }

  handleRemoverMetodoPago = (item) => {
    var listaComprobanteMetodoPago = this.state.formValues.listaComprobanteMetodoPago.filter(m => m.identifier !== item.identifier);
    this.setState({
      formValues: {
        ...this.state.formValues,
        listaComprobanteMetodoPago: listaComprobanteMetodoPago
      }
    });
  };

  handleAddMetodoPago = () => {
    var listaComprobanteMetodoPago = this.state.formValues.listaComprobanteMetodoPago;

    listaComprobanteMetodoPago.push({
      identifier: global.fetchUniqueCode(),
      fechaPago: global.fetchCurrentDateStr(),
      idMetodoPago: 0,
      idCuenta: 0,
      referencia: "",
      montoPago: 0
    });

    this.setState({
      formValues: {
        ...this.state.formValues,
        listaComprobanteMetodoPago: listaComprobanteMetodoPago
      }
    });
  };





  handleChangeProductoModal = (value) => {
    debugger
    if (value != null && value != undefined && value != '') {
      const dataSource = this.state.productos.filter(item => {
        return (item.codigoReferencia + ' - ' + item.nombre)
          .toUpperCase()
          .match(value.toUpperCase());
      });

      this.setState({
        searchProductFormValues: {
          ...this.state.searchProductFormValues,
          dataSource: dataSource
        }
      });
    } else {
      this.setState({
        searchProductFormValues: {
          ...this.state.searchProductFormValues,
          dataSource: this.state.productos
        }
      });
    }
  };


  handleSave = async (item, form) => {
    dialog.confirm("¿Esta seguro de realizar la acción?", async () => {
      var response;

      if (item.id === 0) response = await compraService.registrar(item);
      else response = await compraService.modificar(item);

      if (response.status === 200) {
        form.resetFields();
        formValuesOC = {
          detalleProductos: [],
          listaCompraDetalle: [],
          listaCompraReferencia: [],
          productos: [],
          idOrdenCompra: 0
        };
        this.setState({ visible: false });
        message.success(
          (item.id === 0 ? "Registrado" : "Modificado") + " correctamente."
        );
        this._handlePagination(this.state.filter);
        return;
      }

      if (response.status === 400) {
        dialog.warning(
          <ul>
            {response.data.messages.map((item) => (
              <li>{item}</li>
            ))}
          </ul>
        );
        return;
      }

      dialog.error(
        "Ocurrió un error inesperado, por favor vuelva a intentarlo más tarde."
      );
    });
  };

  handleView = async (item) => {
    debugger;
    this.setState({ loadingVer: true });
    var response = await compraService.obtenerPorId(item.id);

    response.detalles.forEach((element) => {
      const listaCompraDetalleSerie = [];

      response.detalleSerie.forEach((detalleSerie) => {
        if (detalleSerie.idProducto === element.idProducto) {
          listaCompraDetalleSerie.push({
            identifier: global.fetchUniqueCode(),
            idProducto: detalleSerie.idProducto,
            serie: detalleSerie.serie
          });
        }
      });

      element.detalleSeries = listaCompraDetalleSerie.map(u => u.serie).join(', ');
    });

    if (response !== undefined) {
      response.motivos = this.state.motivos;

      this.setState({
        loadingVer: false,
        viewVisible: true,
        viewFormValues: response
      });
    }
  };

  handleEdit = async (item) => {

    this.setState({ loadingEdit: true });
    const response = await compraService.obtenerPorId(item.id);
    var lista_doc = new Array();
    if (response === undefined) {
      this.setState({ loadingEdit: false });
      dialog.error("Ocurrió un error mientras se obtenia los datos.");
      return;
    }
    var params = auth.user().parametros;
    var flagPrecioIncluyeIGV = params.filter((m) => m.abreviatura === VENTA_PRECIO_UNITARIO_INCLUYE_IGV)[0].valor === "1" ? true : false;

    var formValues = {
      flagPrecioIncluyeIGV: flagPrecioIncluyeIGV,
      id: response.id,
      idTipoComprobante: response.idTipoComprobante,
      idProveedor: response.idProveedor,
      idEstablecimientoProveedor: response.idEstablecimientoProveedor,
      idAlmacen: response.idAlmacen,
      idMoneda: response.idMoneda,
      idProyecto: response.idProyecto,
      idPendiente: 1,
      idFormaPago: response.idFormaPago,
      idEstablecimiento: response.idEstablecimiento,
      idDetraccion: response.idDetraccion,
      idPercepcion: response.idPercepcion,

      idUsuarioRegistro: auth.user().id,
      serie: response.serie,
      documento: response.documento,
      fechaStr: response.fechaStr,
      fechaVencimientoStr: response.fechaVencimientoStr,
      fechaRecepcionStr: response.fechaRecepcionStr,
      fechaDocumentoStr: response.fechaDocumentoStr,
      diasVencimiento: response.diasVencimiento,
      tipoCambio: response.tipoCambio,
      observacion: response.observacion,
      flagExportacion: response.flagExportacion,
      flagPercepcion: response.flagPercepcion,
      flagRetencion: response.flagRetencion,
      flagDetraccion: response.flagDetraccion,
      listaCompraDetalle: [],
      listaCompraReferencia: [],
      listaComprobanteCuota: [],
      listaComprobanteMetodoPago: [],
      otroImpuesto: response.otroImpuesto ? 1 : 2,
      monedas: [],
      porcentajeRetencion: response.porcentajeRetencion,
      importeRetencion: response.importeRetencion,
      totalRetencion: response.totalRetencion,

      /*********************/
      activeKey: "1",
      sumaTotalDetalle: response.totalDetalle,
      sumaImporteDescuento: response.importeDescuento,
      sumaSubTotal: response.subTotal,
      sumaIgv: response.igv,
      sumaIsc: response.isc,
      sumaTotal: response.total,
      porcentajeDetraccion: response.porcentajeDetraccion,
      importeDetraccion: response.importeDetraccion,
      totalDetraccion: response.totalDetraccion,
      porcentajePercepcion: response.porcentajePercepcion,
      importePercepcion: response.importePercepcion,
      totalPercepcion: response.totalPercepcion,
      importeDescuentoGlobal: response.importeDescuentoGlobal,
      porcentajeDescuentoGlobal: response.porcentajeDescuentoGlobal,
      flagDescuentoGlobal: response.flagDescuentoGlobal,

      almacenLoading: false,
      clienteLoading: false,
      detalleProductos: [],
      idMotivoNotaCredito: response.idMotivoNotaCredito,
      idTipo: response.idTipoActividad,
      idTipoAlmacen: response.idTipoAlmacen,
      idClasificacion: response.idClasificacion,

      sumaExonerada: response.totalDetalleExonerado,
      sumaInafecta: response.totalDetalleInafecto,
      sumaGratuita: response.totalDetalleGratuito,

    };
    lista_doc = this.handleClasificacion(response.idClasificacion, "idClasificacion");

    response.detalles.forEach((element) => {

      const identifier = global.fetchUniqueCode();

      const listaCompraDetalleSerie = [];

      response.detalleSerie.forEach((detalleSerie) => {
        if (detalleSerie.idProducto === element.idProducto) {
          listaCompraDetalleSerie.push({
            identifier: global.fetchUniqueCode(),
            idProducto: detalleSerie.idProducto,
            serie: detalleSerie.serie
          });
        }
      });

      formValues.listaCompraDetalle.push({
        identifier: identifier,
        idProducto: element.idProducto,
        idTipoProducto: element.idTipoProducto,
        codigo: element.codigoReferencia,
        codigoBarra: element.codigoBarra,
        nombre: element.nombre,
        nombreUnidadMedida: element.nombreUnidadMedida,
        numeroLote: element.numeroLote,
        flagAfecto: element.flagAfecto,
        flagAplicarSerie: element.flagAplicarSerie,
        flagExonerado: element.flagExonerado,
        flagGratuito: element.flagGratuito,
        flagISC: element.flagISC,
        flagVencimiento: element.flagVencimiento,
        numeroRegistroSanitario: element.numeroRegistroSanitario,
        fechaVencimientoStr: element.fechaVencimientoStr,
        isc: element.importeISC,
        precioUnitario: element.precioUnitario,
        precioUnitarioSinIGV: element.precioUnitarioSinIGV,
        cantidad: element.cantidad,
        totalDetalle: element.totalDetalle,
        subTotal: element.subTotal,
        porcentajeDescuento: element.porcentajeDescuento,
        importeDescuento: element.importeDescuento,
        valorUnitario: element.precioUnitario,
        igv: element.igv,
        total: element.total,
        idImpuesto: element.idImpuesto,
        detalleSeries: listaCompraDetalleSerie.map(u => u.serie).join(', '),
        listaCompraDetalleSerie: listaCompraDetalleSerie
      });

      formValues.detalleProductos.push({
        identifier: identifier,
        idProducto: element.idProducto,
        idTipoProducto: element.idTipoProducto,
        codigo: element.codigoReferencia,
        codigoBarra: element.codigoBarra,
        nombre: element.nombre,
        nombreUnidadMedida: element.nombreUnidadMedida,
        numeroLote: element.numeroLote,
        flagAfecto: element.flagAfecto,
        flagAplicarSerie: element.flagAplicarSerie,
        flagExonerado: element.flagExonerado,
        flagGratuito: element.flagGratuito,
        flagISC: element.flagISC,
        flagVencimiento: element.flagVencimiento,
        numeroRegistroSanitario: element.numeroRegistroSanitario,
        fechaVencimientoStr: element.fechaVencimientoStr,
        isc: element.importeISC,
        precioUnitario: element.precioUnitario,
        precioUnitarioSinIGV: element.precioUnitarioSinIGV,
        cantidad: element.cantidad,
        totalDetalle: element.totalDetalle,
        subTotal: element.subTotal,
        porcentajeDescuento: element.porcentajeDescuento,
        importeDescuento: element.importeDescuento,
        valorUnitario: element.precioUnitario,
        igv: element.igv,
        total: element.total,
        idImpuesto: element.idImpuesto,
        detalleSeries: listaCompraDetalleSerie.map(u => u.serie).join(', '),
        listaCompraDetalleSerie: listaCompraDetalleSerie
      });
    });

    response.referencias.forEach((element) => {
      formValues.listaCompraReferencia.push({
        identifier: global.fetchUniqueCode(),
        flagInterno: element.flagInterno,
        idReferenciaOrigen: element.idReferenciaOrigen,
        idReferencia: element.idReferencia,
        idTipoComprobante: element.idTipoComprobante,
        serie: element.serie,
        documento: element.documento,
      });
    });

    response.cuotas.forEach(element => {
      formValues.listaComprobanteCuota.push({
        identifier: global.fetchUniqueCode(),
        correlativo: element.correlativo,
        fechaVencimiento: element.fechaVencimientoStr,
        montoCuota: element.montoCuota,
        estado: element.estado
      });
    });

    response.metodosPagos.forEach(element => {
      formValues.listaComprobanteMetodoPago.push({
        identifier: global.fetchUniqueCode(),
        fechaPago: element.fechaPagoStr,
        idCuenta: element.idCuenta,
        idMetodoPago: element.idMetodoPago,
        montoPago: element.montoPago,
        estado: element.estado
      });
    });


    const proveedores = await proveedorService.listar();
    const proveedorFiltered = proveedores.filter(
      (m) => m.id === formValues.idProveedor
    );
    const almacenes = await await almacenService.listarPorIdEstablecimiento(
      formValues.idEstablecimiento
    );
    const idEntidad =
      proveedorFiltered.length > 0 ? proveedorFiltered[0].idEntidad : 0;
    const direcciones = await establecimientoService.listarPorIdEntidad(
      idEntidad
    );

    formValues.monedas = this.state.monedas ? this.state.monedas : [];
    formValues.formasPago = this.state.formasPago;
    formValues.metodosPagos = this.state.metodosPagos;
    formValues.cuentas = this.state.cuentas;
    formValues.listaBanco = this.state.listaBanco;
    formValues.proyectos = this.state.proyectos;
    formValues.pendientePago = this.state.pendientePago;

    formValues.establecimientos = this.state.establecimientos;
    formValues.vendedores = this.state.vendedores;
    formValues.tiposComprobante = lista_doc.length == 0 ? this.state.tiposComprobante : lista_doc;
    formValues.detracciones = this.state.detracciones;
    formValues.proveedores = proveedores;
    formValues.documentoProveedor =
      proveedorFiltered.length > 0 ? proveedorFiltered[0].numeroDocumento : "";
    formValues.almacenes = almacenes ? almacenes : [];
    formValues.direcciones = direcciones ? direcciones : [];
    formValues.percepciones = this.state.percepciones;

    formValues.TipoAlmacen = this.state.TipoAlmacen;
    formValues.Motivos = this.state.motivos;
    formValues.Tipo = lista_tipo;
    formValues.clasificacion = this.state.clasificacionAll.filter(item => item.codigo == response.idTipoActividad);
    formValues.tiposComprobanteAll = this.state.tiposComprobante;
    formValues.Tipoimpuesto = lst_tipo_impuesto;
    formValues.activeKey = "3";
    formValues.tipoAfectacion = lst_tipo_afectacion;

    this.setState({ loadingEdit: false, visible: true, formValues });

    setTimeout(() => {

      this.setState({
        formValues: {
          ...this.state.formValues,
          activeKey: "1",
        },
      });
    }, 100);
  };


  handleVincular = async (response) => {
    this.setState({ loadingVincular: true });
    var viewVincular = {
      id: response.id,
      fechaStr: response.fechaStr,
      fechaVencimientoStr: response.fechaVencimientoStr,
      fechaRecepcionStr: response.fechaRecepcionStr,
      fechaDocumentoStr: response.fechaDocumentoStr,
      diasVencimiento: response.diasVencimiento,
      tipoCambio: response.tipoCambio,
      sumaTotalDetalle: (response.subTotal).toFixed(2),
      sumaImporteDescuento: response.importeDescuento,
      sumaSubTotal: (response.subTotal).toFixed(2),
      sumaIgv: (response.igv).toFixed(2),
      sumaTotal: (response.total).toFixed(2),
      tiposComprobante: []
    };

    this.setState({ loadingVincular: false, visibleVincular: true, viewVincular, cuotasVinculo: [] });
  };


  handleSaveVincular = async (item, form) => {
    dialog.confirm("¿Esta seguro de realizar la acción?", async () => {

      var response = await compraService.registrarVinculo(item);
      if (response.status === 200) {
        form.resetFields();
        this.setState({ visibleVincular: false });
        message.success("Se vínculo correctamente."
        );
        this._handlePagination(this.state.filter);
        return;
      }

      if (response.status === 400) {
        dialog.warning(
          <ul>
            {response.data.messages.map((item) => (
              <li>{item}</li>
            ))}
          </ul>
        );
        return;
      }

      dialog.error(
        "Ocurrió un error inesperado, por favor vuelva a intentarlo más tarde."
      );
    });
  };

  handleRemoverCuotaVincular = (item) => {

    if (item == undefined) {
      this.setState({
        cuotasVinculo: []

      });
      return false;
    }
    var listaComprobanteCuota = this.state.cuotasVinculo.filter(m => m.identifier !== item.identifier);
    var newListaComprobanteCuota = [];
    var contador = 1;
    listaComprobanteCuota.forEach(element => {
      var cuota = element;
      cuota.correlativo = contador;
      newListaComprobanteCuota.push(cuota);
      contador += 1;
    });

    this.setState({
      cuotasVinculo: listaComprobanteCuota

    });
  };


  handleAddCuotaVincular = () => {

    var intDay = 1
    var listaComprobanteCuota = this.state.cuotasVinculo;
    if (listaComprobanteCuota.length == 0) {
      listaComprobanteCuota.push({
        identifier: global.fetchUniqueCode(),
        correlativo: listaComprobanteCuota.length + 1,
        fechaVencimiento: global.fetchCurrentDayStr1(intDay),
        montoCuota: 0,
        estado: "PENDIENTE"
      });

    } else {

      listaComprobanteCuota.push({
        identifier: global.fetchUniqueCode(),
        correlativo: listaComprobanteCuota.length + 1,
        fechaVencimiento: global.fetchCurrentMonthStr1(intDay, listaComprobanteCuota.length),
        montoCuota: 0,
        estado: "PENDIENTE"
      });
    }

    this.setState({
      cuotasVinculo: listaComprobanteCuota

    });
  };



  handlePago = (value, row) => {

    var detalleBancoFilter = this.state.formValues.listaBanco.filter((m) => {
      return m.id == value;
    });

    var detalleCuentaFilter = this.state.listaCuentas.filter((m) => {
      return m.idEntidad == detalleBancoFilter[0].idEntidad;
    });

    console.log(detalleCuentaFilter);


    this.setState({
      formValues: {
        ...this.state.formValues,
        cuentas: detalleCuentaFilter,
      },
    });


  }


  handleRemoverProducto = (row, form) => {
    this.setState(
      {
        formValues: {
          ...this.state.formValues,
          listaCompraDetalle: this.state.formValues.listaCompraDetalle.filter(
            (m) => m.identifier !== row.identifier
          ),
        },
      },
      () => {
        var detalleProductos = form.getFieldValue("detalleProductos");
        form.setFieldsValue({
          detalleProductos: detalleProductos.filter(
            (m) => m.identifier !== row.identifier
          ),
        });
      }
    );
  };

  handleRemoverReferencia = (item) => {
    var listaCompraReferencia = this.state.formValues.listaCompraReferencia.filter(
      (m) => m.identifier !== item.identifier
    );
    this.setState({
      formValues: {
        ...this.state.formValues,
        listaCompraReferencia: listaCompraReferencia,
      },
    });
  };

  handleEditarNombreProducto = (row, onSetFieldsValue, onGetFieldValue) => {
    var formValues = {
      id: row.identifier,
      nombre: onGetFieldValue(`arrNombre[${row.identifier}]`),
    };

    this.setState({
      editarNombreProductoVisible: true,
      editarNombreProductoFormValues: formValues,
      onSetFieldsValue,
      onGetFieldValue,
    });
  };

  handleSaveEditarNombreProducto = (values, form) => {
    form.resetFields();
    this.setState({ editarNombreProductoVisible: false });
    var detalleProductos = this.state.onGetFieldValue("detalleProductos");
    detalleProductos.forEach((item) => {
      if (item.identifier === values.id) {
        item.nombre = values.nombre;
        return;
      }
    });

    this.state.onSetFieldsValue({
      detalleProductos,
      [`arrNombre[${values.id}]`]: values.nombre,
    });
  };

  handleExportExcel = async () => {
    var response = await compraService.excel(this.state.filter);
    if (response !== undefined)
      global.dowloadFile(response.data, "Reporte de Ingresos.xlsx");
  };

  handleExportPdf = async () => {
    this.setState({ loadingPdf: true });
    var response = await compraService.pdf(this.state.filter);
    this.setState({ loadingPdf: false });
    if (response !== undefined)
      global.dowloadFile(response.data, "Reporte de Ingresos.pdf");
  };

  handleDetalleExportExcel = async () => {
    this.setState({ loadingExcel: true });

    var response = await compraService.excelDetallado(this.state.filter);
    this.setState({ loadingExcel: false });

    if (response !== undefined)
      global.dowloadFile(response.data, "Reporte de Compras Detallado.xlsx");
  }

  handleDetalleExportPdf = async () => {
    this.setState({ loadingPdf: true });
    var response = await compraService.pdfDetallado(this.state.filter);
    this.setState({ loadingPdf: false });
    if (response !== undefined)
      global.dowloadFile(response.data, "Reporte de Compras Detallado.pdf");
  }


  handleAnular = async (item) => {

    var flagAnular = this.state.configuraciones.filter((m) => m.abreviatura === APROBAR_CO).length >= 1 ? true : false;

    if (!flagAnular) {
      message.warning('Usted no puede anular compra.');
      return false;
    }
    dialog.confirm(
      `¿Desea anular la compra ${item.serie}-${item.documento}?`,
      async () => {
        var response = await compraService.anular({ id: item.id });

        if (response.status === 200) {
          dialog.success(
            `Compra ${item.serie}-${item.documento} anulado correctamente.`
          );
          this._handlePagination(this.state.filter);
          return;
        }

        if (response.status === 400) {
          dialog.warning(
            <ul>
              {response.data.messages.map((item) => (
                <li>{item}</li>
              ))}
            </ul>
          );
          return;
        }

        dialog.error(
          "Ocurrió un error inesperado, por favor vuelva a intentarlo más tarde."
        );
      }
    );
  };

  handleAprobar = async (item) => {
    var flagAnular = this.state.configuraciones.filter((m) => m.abreviatura === APROBAR_CO).length >= 1 ? true : false;

    if (!flagAnular) {
      message.warning('Usted no puede aprobar compra.');
      return false;
    }
    dialog.confirm(
      `¿Desea aprobar la compra ${item.serie}-${item.documento} a los movimientos de ingresos y salidas?`,
      async () => {
        var response = await compraService.aprobar({ id: item.id });

        if (response.status === 200) {
          dialog.success(
            `Compra ${item.serie}-${item.documento} aprobado correctamente.`
          );
          this._handlePagination(this.state.filter);
          return;
        }

        if (response.status === 400) {
          dialog.warning(
            <ul>
              {response.data.messages.map((item) => (
                <li>{item}</li>
              ))}
            </ul>
          );
          return;
        }

        dialog.error(
          "Ocurrió un error inesperado, por favor vuelva a intentarlo más tarde."
        );
      }
    );
  };


  handleImportarOC = async (onSetFieldsValue, onGetFieldValue) => {
    debugger
    this.setState({
      onSetFieldsValue,
      onGetFieldValue
    }, async () => {

      var idProveedor = this.state.onGetFieldValue("idProveedor");

      if (idProveedor == null || idProveedor == undefined) {
        dialog.error("Seleccione un proveedor");
        return false;
      }

      var filterSearchOC = {
        idEstadoRequerimiento: APROBADO,
        filtro: '',
        idProveedor: idProveedor.key
      };

      var response = this.state.formValues.idTipo == 1 ? await ordenServiceService.listarPorEstado(filterSearchOC) : await ordenCompraService.listarPorEstado(filterSearchOC);

      if (this.state.formValues.idTipo == 1) {
        this.setState({
          importarOSVisible: true,
          importarOrdenCompraModal: {
            ...this.state.importarOrdenCompraModal,
            idOrdenCompra: 0,
            dataSource: response,
            dataSourceDetalle: []
          }
        });
      } else {

        this.setState({
          importarOCVisible: true,
          importarCotizacionFormValues: {
            ...this.state.importarCotizacionFormValues,
            dataSource: response,
            selectedRowKeys: this.state.formValues.listaCompraReferencia.map(function (v) {
              return v.serie + '-' + v.documento;
            })
          },
        });


      }




    });



  }


  handleSelectRowOrdenCompra = async (row) => {

    const response = this.state.formValues.idTipo == 1 ? await ordenServiceService.obtenerPorId(row.id) : await ordenCompraService.obtenerPorId(row.id);
    if (response !== undefined) {

      response.ordenCompra = this.state.formValues.idTipo == 1 ? response.ordenServicio : response.ordenCompra;

      formValuesOC.idMoneda = response.ordenCompra.idMoneda;
      formValuesOC.subTotal = response.ordenCompra.subTotal;
      formValuesOC.igv = response.ordenCompra.igv;
      formValuesOC.total = response.ordenCompra.total;
      formValuesOC.idProveedor = response.ordenCompra.idProveedor;
      formValuesOC.documentoProveedor = response.ordenCompra.documentoProveedor;
      formValuesOC.idEntidad = response.ordenCompra.idEntidadProveedor;
      formValuesOC.idEstablecimiento = response.ordenCompra.idEstablecimiento;
      formValuesOC.idProyecto = response.ordenCompra.idProyecto;
      formValuesOC.otroImpuesto = 1;
      formValuesOC.productos = [];
      formValuesOC.detalleProductos = [];
      formValuesOC.listaCompraDetalle = [];
      formValuesOC.listaCompraReferencia = [];
      formValuesOC.idOrdenCompra = row.id;
      var listaDetalle = this.state.formValues.idTipo == 1 ? response.ordenServicioDetalles : response.ordenCompraDetalles;

      for (var i = 0; i < listaDetalle.length; i++) {
        var item = listaDetalle[i];
        var identifier = global.fetchUniqueCode();
        var precioNew = (item.precioUnitario * 1.18).toFixed(2);
        var oneProd = {
          identifier: identifier,
          idProducto: item.idProducto,
          nombre: item.nombre,
          cantidad: item.cantidad,
          codigo: item.codigoReferencia,
          nombreUnidadMedida: item.nombreUnidadMedida,
          precioUnitario: item.precioUnitario,
          total: item.total,
          valorUnitario: item.flagAfecto ? precioNew : item.precioUnitario,
          flagAfecto: item.flagAfecto,
          flagGratuito: item.flagGratuito,
          precioUnitarioSinIGV: item.precioUnitarioSinIGV,
          subTotal: item.subTotal,
          igv: item.igv,
          isc: 0,
          totalDetalle: (item.precioUnitarioSinIGV * item.cantidad),
          porcentajeDescuento: 0,
          importeDescuento: 0,
          flagVencimiento: item.flagVencimiento,
          fechaVencimientoStr: item.flagVencimiento ? global.fetchCurrentDateStr() : null,

        }
        formValuesOC.productos.push(item.idProducto);
        formValuesOC.listaCompraDetalle.push(oneProd);

        var detalleProducto = {
          identifier: identifier,
          nombre: item.nombre,
          cantidad: item.cantidad,
          fechaProduccionStr: this.state.formValues.fechaStr,
          fechaVencimientoStr: this.state.formValues.fechaStr,
          flagAfecto: item.flagAfecto,
          flagGratuito: item.flagGratuito,
          flagExonerado: false,
          flagISC: false,
          idProducto: item.idProducto,
          igv: item.igv,
          lote: item.numeroLote,
          precioUnitario: item.precioUnitario,
          porcentajeDescuento: 0,
          importeDescuento: 0,
          subTotal: item.subTotal,
          total: item.total,
          precioUnitarioSinIGV: item.precioUnitarioSinIGV,
          flagVencimiento: item.flagVencimiento,
          fechaVencimientoStr: item.flagVencimiento ? global.fetchCurrentDateStr() : null,
          valorUnitario: item.flagAfecto ? precioNew : item.precioUnitario,

        };

        formValuesOC.detalleProductos.push(detalleProducto);
      }

      var oneRef = {
        identifier: global.fetchUniqueCode(),
        idReferencia: response.ordenCompra.id,
        idReferenciaOrigen: this.state.formValues.idTipo == 1 ? LOGISTICA_ORDEN_SERVICIO : LOGISTICA_ORDEN_COMPRA,
        idTipoComprobante: response.ordenCompra.idTipoComprobante,
        serie: response.ordenCompra.serie,
        documento: response.ordenCompra.documento,
        flagInterno: true
      }

      formValuesOC.listaCompraReferencia.push(oneRef);

      this.setState({
        importarOSVisible: true,
        importarOrdenCompraModal: {
          ...this.state.importarOrdenCompraModal,
          dataSourceDetalle: formValuesOC.listaCompraDetalle,
          detalleProductos: formValuesOC.detalleProductos
        }
      })
    }
  }

  handleOkImportarOrdenCompra = async (values, form) => {

    if (formValuesOC === null || formValuesOC === undefined || formValuesOC.idOrdenCompra === 0) {
      dialog.warning("Seleccione una orden de compra;");
      return;
    }

    var listaMetodoPago = [];


    this.setState({
      formValues: {
        ...this.state.formValues,
        listaComprobanteMetodoPago: listaMetodoPago
      }
    });

    const almacenes = await almacenService.listarPorIdEstablecimiento(formValuesOC.idEstablecimiento);

    const direcciones = await establecimientoService.listarPorIdEntidad(
      formValuesOC.idEntidad
    );


    listaMetodoPago.push({
      identifier: global.fetchUniqueCode(),
      fechaPago: global.fetchCurrentDateStr(),
      idMetodoPago: 4, //efectivo
      idCuenta: 0,
      referencia: "",
      montoPago: formValuesOC.total
    });


    this.setState({
      visible: true,
      importarOSVisible: false,
      formValues: {
        ...this.state.formValues,
        idProveedor: formValuesOC.idProveedor,
        idEstablecimientoProveedor: direcciones[0].id,
        idMoneda: formValuesOC.idMoneda,
        idProyecto: formValuesOC.idProyecto,
        idEstablecimiento: formValuesOC.idEstablecimiento,
        idAlmacen: formValuesOC.idAlmacen,
        sumaSubTotal: formValuesOC.subTotal,
        sumaIgv: formValuesOC.igv,
        sumaTotal: formValuesOC.total,
        almacenes: almacenes,
        direcciones: direcciones,
        detalleProductos: formValuesOC.detalleProductos,
        listaCompraDetalle: formValuesOC.listaCompraDetalle,
        listaCompraReferencia: formValuesOC.listaCompraReferencia,
        activeKey: "2",
        //tiposComprobante: this.state.tiposComprobante 

      },
      productoModal: {
        ...this.state.productoModal,
        selectedRowKeys: formValuesOC.productos
      }
    }, () => {

      this.state.onSetFieldsValue({
        idProveedor: formValuesOC.idProveedor !== 0 ? { key: formValuesOC.idProveedor } : undefined,
        documentoProveedor: formValuesOC.documentoProveedor,
        idEstablecimientoProveedor:
          direcciones[0].id !== 0
            ? { key: direcciones[0].id }
            : undefined,
        idEstablecimiento: { key: formValuesOC.idEstablecimiento },
        idProyecto: { key: formValuesOC.idProyecto },
        //idTipoAlmacen: { key: 1 },
        idMoneda: { key: formValuesOC.idMoneda },
        detalleProductos: formValuesOC.detalleProductos,
        sumaSubTotal: formValuesOC.subTotal,
        sumaIgv: formValuesOC.igv,
        sumaTotal: formValuesOC.total
      });
    });
  }

  handleBuscarProveedor = async (value, form) => {
    this.setState({
      formValues: { ...this.state.formValues, proveedorLoading: true },
    });

    //const response = await padronReducidoService.logistica_proveedor(value);

    var numberDocument = form.getFieldValue("documentoProveedor");
    if (numberDocument == "" || numberDocument == "null" || numberDocument == "undefined") {
      dialog.warning(<ul>Ingrese documento valido</ul>);

      return;
    }

    var response = numberDocument.length == 8 ? await padronReducidoService.obtenerProveedorDniApi(value) :
      await padronReducidoService.obtenerProveedorRucApi(value);
    if (response.status === 400) {
      dialog.warning(<ul>{response.data.messages.map(item => (<li>{item}</li>))}</ul>);
      this.setState({ formValues: { ...this.state.formValues, proveedorLoading: false } });

      return;
    }

    if (response.status === 200) {
      this.setState(
        {
          formValues: {
            ...this.state.formValues,
            proveedorLoading: false,
            direcciones: response.data.direcciones,
          },
        },
        () => {
          form.setFieldsValue({
            proveedores: response.data.proveedores,
            idProveedor:
              response.data.proveedores.length > 0
                ? { key: response.data.proveedores[0].id }
                : undefined,
            idEstablecimientoProveedor:
              response.data.direcciones.length > 0
                ? { key: response.data.direcciones[0].id }
                : undefined,
            direccionProveedor:
              response.data.direcciones.length > 0
                ? response.data.direcciones[0].direccion
                : ""
          });
        }
      );
    } else {
      this.setState(
        {
          formValues: {
            ...this.state.formValues,
            proveedorLoading: false,
            direcciones: [],
          },
        },
        () => {
          form.setFieldsValue({
            proveedores: [],
            idProveedor: undefined,
            idEstablecimientoProveedor: undefined,
          });
        }
      );
    }
  };


  handleScaner = async (value, onSetFieldsValue, onGetFieldValue, onCalculateDetail) => {
    debugger;

    /*Scanear Serie*/
    if (this.state.agregarSerieVisible) {
      debugger;

      this.handleAgregarSerieDetalle({ idProducto: this.state.agregarSerieModal.idProducto, serie: value, onCalculateDetail: onCalculateDetail });

      return;
    }

    /*Scanear Producto*/

    this.setState({
      onSetFieldsValue,
      onGetFieldValue,
    });

    var flagPrecioIncluyeIGV = false;
    var porcentajeIGV = 18;
    /* LSITA */
    var listaCompraDetalle = this.state.formValues.listaCompraDetalle;
    var filter_detalle = listaCompraDetalle.filter((m) => m.codigoBarra === value);

    const index = listaCompraDetalle.map(i => i.codigoBarra).indexOf(value);

    var item = {};
    if (filter_detalle.length > 0) {
      var item = filter_detalle[0];

      if (item.flagAplicarSerie) {
        dialog.error("El producto ya se encuentra agregado.");
        return;
      }

      listaCompraDetalle = listaCompraDetalle.filter((m) => m.codigoBarra !== value);

      var _precioUnitario = this.state.onGetFieldValue(`arrPrecioUnitario[${item.identifier}]`);
      var _cantidad = this.state.onGetFieldValue(`arrCantidad[${item.identifier}]`);

      item.cantidad = parseInt(_cantidad,) + 1;
      item.precioUnitario = (_precioUnitario == undefined || _precioUnitario == null) ? 0 : parseFloat(_precioUnitario);

    } else {

      var list = await productoService.listarBarras(value);
      var filter_list = list.filter((m) => m.codigoBarra === value);
      if (filter_list.length === 0) {
        dialog.error("No existe el producto con codigo " + value);
        return;
      }
      var row = filter_list[0];

      item = {
        identifier: global.fetchUniqueCode(),
        idProducto: row.id,
        idTipoProducto: row.idTipoProducto,
        codigo: row.codigoReferencia,
        codigoBarra: row.codigoBarra,
        nombre: row.nombre,
        nombreUnidadMedida: row.nombreUnidadMedida,
        flagAplicarSerie: row.flagAplicarSerie,
        flagAfecto: row.flagIGVAfecto,
        flagGratuito: row.flagGratuito,
        flagISC: row.flagISC,
        flagExonerado: row.flagExonerado,
        isc: 0,
        flagVencimiento: row.flagVencimiento,
        fechaVencimientoStr: row.flagVencimiento ? global.fetchCurrentDateStr() : null,
        fechaProduccionStr: global.fetchCurrentDateStr(),
        precioUnitario: 0,
        valorUnitario: 0,
        precioUnitarioSinIGV: 0,
        cantidad: row.flagAplicarSerie ? 0 : 1,
        totalDetalle: 0,
        numeroLote: '',
        porcentajeDescuento: 0,
        importeDescuento: 0,
        subTotal: 0,
        igv: 0,
        total: 0,
        listaCompraDetalleSerie: []
      };
    }

    /* CALCULOS */
    var divisorCalculoSubTotal = 1 + porcentajeIGV / 100;

    item.totalDetalle = item.cantidad * item.precioUnitario;
    item.subTotal = item.cantidad * item.precioUnitario;
    item.igv = parseFloat(item.flagAfecto ? item.subTotal * (porcentajeIGV / 100) : 0);
    item.total = item.subTotal + item.igv;
    /* CALCULOS */

    listaCompraDetalle.splice(index, 0, item);

    var detalleProductos = this.state.onGetFieldValue("detalleProductos");
    detalleProductos = detalleProductos.filter((m) => m.identifier !== item.identifier);

    this.setState(
      {
        formValues: {
          ...this.state.formValues,
          listaCompraDetalle: listaCompraDetalle,
          detalleProductos: listaCompraDetalle,
          sumaTotalDetalle: detalleProductos.reduce((a, b) => a + (b["totalDetalle"] || 0), 0),
          sumaSubTotal: detalleProductos.reduce((a, b) => a + (b["subTotal"] || 0), 0),
          sumaIgv: detalleProductos.reduce((a, b) => a + (b["igv"] || 0), 0),
          sumaTotal: detalleProductos.reduce((a, b) => a + (b["total"] || 0), 0),
        },
      },
      () => {

        var producto = {
          identifier: item.identifier,
          idProducto: item.idProducto,
          idTipoProducto: item.idTipoProducto,
          codigo: item.codigoReferencia,
          codigoBarra: item.codigoBarra,
          nombre: item.nombre,
          nombreUnidadMedida: item.nombreUnidadMedida,
          flagAplicarSerie: item.flagAplicarSerie,
          flagAfecto: item.flagIGVAfecto,
          flagGratuito: item.flagGratuito,
          flagISC: item.flagISC,
          flagExonerado: item.flagExonerado,
          isc: item.isc,
          flagVencimiento: item.flagVencimiento,
          fechaVencimientoStr: item.fechaVencimientoStr,
          fechaProduccionStr: item.fechaProduccionStr,
          precioUnitario: item.precioUnitario,
          valorUnitario: item.valorUnitario,
          precioUnitarioSinIGV: item.precioUnitarioSinIGV,
          cantidad: item.cantidad,
          totalDetalle: item.totalDetalle,
          numeroLote: item.numeroLote,
          porcentajeDescuento: item.porcentajeDescuento,
          importeDescuento: item.importeDescuento,
          subTotal: item.subTotal,
          igv: item.igv,
          total: item.total,
          listaCompraDetalleSerie: item.listaCompraDetalleSerie
        };

        detalleProductos.splice(index, 0, producto);

        this.state.onSetFieldsValue({
          [`arrCantidad[${item.identifier}]`]: item.cantidad.toFixed(3),
          [`arrTotalDetalle[${item.identifier}]`]: item.totalDetalle.toFixed(2),
          [`arrSubTotal[${item.identifier}]`]: item.subTotal.toFixed(2),
          [`arrIgv[${item.identifier}]`]: item.igv.toFixed(2),
          [`arrTotal[${item.identifier}]`]: item.total.toFixed(2),

          sumaTotalDetalle: detalleProductos.reduce((a, b) => a + (b["totalDetalle"] || 0), 0),
          sumaSubTotal: detalleProductos.reduce((a, b) => a + (b["subTotal"] || 0), 0),
          sumaIgv: detalleProductos.reduce((a, b) => a + (b["igv"] || 0), 0),
          sumaTotal: detalleProductos.reduce((a, b) => a + (b["total"] || 0), 0),
          detalleProductos: detalleProductos,
        });
      }
    );
    message.success("Producto agregado");

  };


  handleImportarCompra = async (onSetFieldsValue, onGetFieldValue) => {

    this.setState({
      onSetFieldsValue,
      onGetFieldValue
    }, async () => {

      var idProveedor = this.state.onGetFieldValue("idProveedor");

      if (idProveedor == null || idProveedor == undefined) {
        dialog.error("Seleccione un proveedor");
        return false;
      }

      var filter = {
        idEstado: APROBADO_COMPRA,
        filtro: '',
        idProveedor: idProveedor.key
      };

      var ordenesCompra = await compraService.listarPorEstado(filter);

      this.setState({
        importarCompraVisible: true,
        importarCompraModal: {
          ...this.state.importarCompraModal,
          idCompra: 0,
          dataSource: ordenesCompra,
          dataSourceDetalle: []
        }
      });
    });
  }


  handleSelectRowCompra = async (row) => {

    const response = await compraService.obtenerPorId(row.id);
    if (response !== undefined) {


      formValuesOC.idMoneda = response.idMoneda;
      formValuesOC.subTotal = response.subTotal;
      formValuesOC.igv = response.igv;
      formValuesOC.total = response.total;
      formValuesOC.idProveedor = response.idProveedor;
      formValuesOC.documentoProveedor = response.numeroDocumentoProveedor;
      formValuesOC.idEntidad = response.idEntidadProveedor;
      formValuesOC.idEstablecimiento = response.idEstablecimiento;
      formValuesOC.idAlmacen = response.idAlmacen;
      formValuesOC.idProyecto = response.idProyecto;
      formValuesOC.otroImpuesto = 1;
      formValuesOC.productos = [];
      formValuesOC.detalleProductos = [];
      formValuesOC.listaCompraDetalle = [];
      formValuesOC.listaCompraReferencia = [];
      formValuesOC.idCompra = row.id;
      var listaDetalle = response.detalles;

      for (var i = 0; i < listaDetalle.length; i++) {
        var item = listaDetalle[i];
        var identifier = global.fetchUniqueCode();
        var precioNew = (item.precioUnitario * 1.18).toFixed(2);
        var oneProd = {
          identifier: identifier,
          idProducto: item.idProducto,
          nombre: item.nombre,
          cantidad: item.cantidad,
          codigo: item.codigoReferencia,
          nombreUnidadMedida: item.nombreUnidadMedida,
          precioUnitario: item.precioUnitario,
          total: item.total,
          valorUnitario: item.flagAfecto ? precioNew : item.precioUnitario,
          flagAfecto: item.flagAfecto,
          flagGratuito: item.flagGratuito,
          precioUnitarioSinIGV: item.precioUnitarioSinIGV,
          subTotal: item.subTotal,
          igv: item.igv,
          isc: 0,
          totalDetalle: (item.precioUnitarioSinIGV * item.cantidad),
          porcentajeDescuento: 0,
          importeDescuento: 0,
          flagVencimiento: item.flagVencimiento,
          fechaVencimientoStr: item.flagVencimiento ? global.fetchCurrentDateStr() : null,

        }
        formValuesOC.productos.push(item.idProducto);
        formValuesOC.listaCompraDetalle.push(oneProd);

        var detalleProducto = {
          identifier: identifier,
          nombre: item.nombre,
          cantidad: item.cantidad,
          fechaProduccionStr: this.state.formValues.fechaStr,
          fechaVencimientoStr: this.state.formValues.fechaStr,
          flagAfecto: item.flagAfecto,
          flagGratuito: item.flagGratuito,
          flagExonerado: false,
          flagISC: false,
          idProducto: item.idProducto,
          igv: item.igv,
          lote: item.numeroLote,
          precioUnitario: item.precioUnitario,
          porcentajeDescuento: 0,
          importeDescuento: 0,
          subTotal: item.subTotal,
          total: item.total,
          precioUnitarioSinIGV: item.precioUnitarioSinIGV,
          flagVencimiento: item.flagVencimiento,
          fechaVencimientoStr: item.flagVencimiento ? global.fetchCurrentDateStr() : null,
          valorUnitario: item.flagAfecto ? precioNew : item.precioUnitario,

        };

        formValuesOC.detalleProductos.push(detalleProducto);
      }

      var oneRef = {
        identifier: global.fetchUniqueCode(),
        idReferencia: response.id,
        idReferenciaOrigen: LOGISTICA_COMPRA,
        idTipoComprobante: response.idTipoComprobante,
        serie: response.serie,
        documento: response.documento,
        flagInterno: true
      }

      formValuesOC.listaCompraReferencia.push(oneRef);

      this.setState({
        importarCompraVisible: true,
        importarCompraModal: {
          ...this.state.importarCompraModal,
          dataSourceDetalle: formValuesOC.listaCompraDetalle,
          detalleProductos: formValuesOC.detalleProductos
        }
      })
    }
  }

  handleOkImportarCompra = async (values, form) => {

    if (formValuesOC === null || formValuesOC === undefined || formValuesOC.idCompra === 0) {
      dialog.warning("Seleccione una orden de compra;");
      return;
    }

    var listaMetodoPago = [];


    this.setState({
      formValues: {
        ...this.state.formValues,
        listaComprobanteMetodoPago: listaMetodoPago
      }
    });

    const almacenes = await almacenService.listarPorIdEstablecimiento(formValuesOC.idEstablecimiento);

    const direcciones = await establecimientoService.listarPorIdEntidad(
      formValuesOC.idEntidad
    );


    listaMetodoPago.push({
      identifier: global.fetchUniqueCode(),
      fechaPago: global.fetchCurrentDateStr(),
      idMetodoPago: 4, //efectivo
      idCuenta: 0,
      referencia: "",
      montoPago: formValuesOC.total
    });


    this.setState({
      visible: true,
      importarCompraVisible: false,
      formValues: {
        ...this.state.formValues,
        idProveedor: formValuesOC.idProveedor,
        idEstablecimientoProveedor: direcciones[0].id,
        idMoneda: formValuesOC.idMoneda,
        idProyecto: formValuesOC.idProyecto,
        idEstablecimiento: formValuesOC.idEstablecimiento,
        idAlmacen: formValuesOC.idAlmacen,
        sumaSubTotal: formValuesOC.subTotal,
        sumaIgv: formValuesOC.igv,
        sumaTotal: formValuesOC.total,
        almacenes: almacenes,
        direcciones: direcciones,
        detalleProductos: formValuesOC.detalleProductos,
        listaCompraDetalle: formValuesOC.listaCompraDetalle,
        listaCompraReferencia: formValuesOC.listaCompraReferencia,
        activeKey: "2",
        //tiposComprobante: this.state.tiposComprobante 

      },
      productoModal: {
        ...this.state.productoModal,
        selectedRowKeys: formValuesOC.productos
      }
    }, () => {

      this.state.onSetFieldsValue({
        idProveedor: formValuesOC.idProveedor !== 0 ? { key: formValuesOC.idProveedor } : undefined,
        documentoProveedor: formValuesOC.documentoProveedor,
        idEstablecimientoProveedor: direcciones[0].id !== 0 ? { key: direcciones[0].id } : undefined,
        idEstablecimiento: { key: formValuesOC.idEstablecimiento },
        idProyecto: { key: formValuesOC.idProyecto },
        idTipoAlmacen: { key: 1 },
        idMoneda: { key: formValuesOC.idMoneda },
        detalleProductos: formValuesOC.detalleProductos,
        sumaSubTotal: formValuesOC.subTotal,
        sumaIgv: formValuesOC.igv,
        sumaTotal: formValuesOC.total
      });
    });
  }


  handleSelectCotizacion = async (selected, row, form) => {
    debugger
    var response = undefined;
    var productos = this.state.onGetFieldValue("detalleProductos");

    var listaCompraDetalle = this.state.formValues.listaCompraDetalle;
    var listaCompraReferencia = this.state.formValues.listaCompraReferencia;

    var sumaTotalDetalle = 0;
    var sumaImporteDescuento = 0;
    var sumaSubTotal = 0;
    var sumaIgv = 0;
    var sumaIsc = 0;
    var sumaTotal = 0;
    var obj = {};
    var totalMetodoPago = 0;



    if (row.length == 0) {

      listaCompraDetalle = listaCompraDetalle.filter(e => e.importado == true);
      listaCompraReferencia = listaCompraReferencia.filter(e => e.importado == true);
      productos = productos.filter(e => e.importado == true);

      if (listaCompraReferencia.length > 0)
        totalMetodoPago = parseFloat(listaCompraDetalle.reduce((a, b) => a + (b["total"] || 0), 0));


      setTimeout(() => {
        this.setState({
          formValues: {
            ...this.state.formValues,
            listaCompraDetalle,
            listaCompraReferencia
          },
          importarCotizacionFormValues: {
            ...this.state.importarCotizacionFormValues,
            selectedRowKeys: selected
          }
        })

        this.state.onSetFieldsValue({

          detalleProductos: productos,
          sumaTotalDetalle: sumaTotalDetalle + (totalMetodoPago / 1.18),
          sumaImporteDescuento: sumaImporteDescuento,
          sumaSubTotal: sumaSubTotal + (totalMetodoPago / 1.18),
          sumaIgv: sumaIgv + (totalMetodoPago - (totalMetodoPago / 1.18)),
          sumaIsc: sumaIsc,
          sumaTotal: sumaTotal + totalMetodoPago
        });
      }, 100)
    }
    if (row.length == 1) {

      listaCompraDetalle = listaCompraDetalle.filter(e => e.importado == true);
      listaCompraReferencia = listaCompraReferencia.filter(e => e.importado == true);
      productos = productos.filter(e => e.importado == true);

      if (listaCompraReferencia.length > 0)
        totalMetodoPago = parseFloat(listaCompraDetalle.reduce((a, b) => a + (b["total"] || 0), 0));

      response = await ordenCompraService.obtenerPorId(row[0].id);

      response.ordenCompraDetalles.forEach(element => {
        const identifier = global.fetchUniqueCode();
        var precioNew = (element.precioUnitario * 1.18).toFixed(2);

        listaCompraDetalle.push({
          identifier: identifier,
          idProducto: element.idProducto,
          idTipoProducto: element.idTipoProducto,
          codigo: element.codigoReferencia,
          nombre: element.nombre,
          numeroLote: element.numeroLote,
          nombreUnidadMedida: element.nombreUnidadMedida,
          idUnidadMedida: element.idUnidadMedida,
          flagAfecto: element.flagAfecto,
          flagGratuito: element.flagGratuito,
          flagISC: element.flagISC,
          isc: element.importeISC,
          porcentajeMargenComercial: element.porcentajeMargenComercial,
          precioPromedio: element.precioPromedio,
          precioUnitario: element.precioUnitario,
          precioUnitarioSinIGV: element.precioUnitarioSinIGV,
          valorUnitario: element.flagAfecto ? precioNew : element.precioUnitario,
          cantidad: element.cantidad,
          porcentajeDescuento: 0,
          importeDescuento: 0,
          subTotal: element.subTotal,
          igv: element.igv,
          total: element.total,
          idImpuesto: element.idImpuesto ?? 1,
          importado: false,
          flagConversion: element.flagConversion,
          totalDetalle: (element.precioUnitarioSinIGV * element.cantidad),

        });

        productos.push({
          identifier: identifier,
          idProducto: element.idProducto,
          idTipoProducto: element.idTipoProducto,
          nombre: element.nombre,
          numeroLote: element.numeroLote,
          cantidad: element.cantidad,
          idUnidadMedida: element.idUnidadMedida,
          porcentajeMargenComercial: element.porcentajeMargenComercial,
          precioPromedio: element.precioPromedio,
          precioUnitarioSinIGV: element.precioUnitarioSinIGV,
          precioUnitario: element.precioUnitario,
          valorUnitario: element.flagAfecto ? precioNew : element.precioUnitario,
          idImpuesto: element.idImpuesto ?? 1,
          porcentajeDescuento: 0,
          importeDescuento: 0,
          total: element.total,
          flagAfecto: element.flagAfecto,
          flagISC: element.flagISC,
          flagOtrosImpuesto: element.flagOtrosImpuesto,
          flagGratuito: element.flagGratuito,
          flagChangeTotal: element.flagChangeTotal,
          subTotal: element.subTotal,
          importado: false,
          flagConversion: element.flagConversion,
          totalDetalle: (element.precioUnitarioSinIGV * element.cantidad),

        });

      });


      listaCompraReferencia.push({

        identifier: global.fetchUniqueCode(),
        idReferencia: response.ordenCompra.id,
        idReferenciaOrigen: LOGISTICA_ORDEN_COMPRA,
        idTipoComprobante: response.ordenCompra.idTipoComprobante,
        serie: response.ordenCompra.serie,
        documento: response.ordenCompra.documento,
        flagInterno: true,
        importado: false
      });

      listaCompraReferencia = listaCompraReferencia.filter(m => selected.filter(f => f === m.serie + '-' + m.documento).length);
      //totalMetodoPago = (totalMetodoPago - this.state.formValues.totalAnticipo);

      obj = {
        sumaTotalDetalle: response.ordenCompra.subTotal + (totalMetodoPago / 1.18),
        sumaImporteDescuento: response.ordenCompra.importeDescuento + sumaImporteDescuento,
        sumaSubTotal: response.ordenCompra.subTotal + (totalMetodoPago / 1.18),
        sumaIgv: response.ordenCompra.igv + (totalMetodoPago - (totalMetodoPago / 1.18)),
        sumaIsc: response.ordenCompra.isc + sumaIsc,
        sumaTotal: response.ordenCompra.total + totalMetodoPago,
      }


      this.SelectCotizacion(response, listaCompraDetalle, productos, listaCompraReferencia, selected, obj);

    }

    var contador = 0;
    if (row.length > 1) {

      listaCompraDetalle = listaCompraDetalle.filter(e => e.importado == true);
      listaCompraReferencia = listaCompraReferencia.filter(e => e.importado == true);
      productos = productos.filter(e => e.importado == true);

      if (listaCompraReferencia.length > 0)
        totalMetodoPago = parseFloat(listaCompraDetalle.reduce((a, b) => a + (b["total"] || 0), 0));

      row.forEach(async (item) => {

        response = await ordenCompraService.obtenerPorId(item.id);

        response.ordenCompraDetalles.forEach(element => {

          const precioNuevo = element.flagAfecto
            ? (element.precioUnitario * 1.18)
            : element.precioUnitario;

          // Buscar si ya existe ese producto en la lista
          const existente = listaCompraDetalle.find(x => x.idProducto === element.idProducto);

          if (existente) {
            // SI EL PRODUCTO YA EXISTE → UNIR DATOS
            const ProdExistente = productos.find(x => x.idProducto === element.idProducto);

            // Nuevo precio ponderado
            const totalCant = existente.cantidad + element.cantidad;

            const precioPonderado = (
              (existente.precioUnitario * existente.cantidad) +
              (element.precioUnitario * element.cantidad)
            ) / totalCant;

            // Actualizar valores
            existente.cantidad = totalCant;
            existente.precioUnitario = precioPonderado;
            existente.valorUnitario = existente.flagAfecto
              ? (precioPonderado * 1.18)
              : precioPonderado;

            // Recalcular totales
            existente.totalDetalle = existente.precioUnitario * existente.cantidad;
            existente.total = existente.totalDetalle;
            existente.subTotal = existente.totalDetalle / 1.18;
            existente.igv = existente.totalDetalle - existente.subTotal;
            existente.precioUnitarioSinIGV = precioPonderado / 1.18;

            //cambio de valor producto
            ProdExistente.cantidad = totalCant;
            ProdExistente.precioUnitario = existente.precioUnitario;
            ProdExistente.valorUnitario = existente.valorUnitario;
            ProdExistente.totalDetalle = existente.totalDetalle;
            ProdExistente.total = existente.total;
            ProdExistente.subTotal = existente.subTotal;
            ProdExistente.igv = existente.igv;
            ProdExistente.precioUnitarioSinIGV = existente.precioUnitarioSinIGV;


            //dialog.error(`El producto "${element.nombre}" ya fue agregado. Evite duplicados.`);
            //return;
          } else {
            // SI NO EXISTE → AGREGAR NUEVO
            listaCompraDetalle.push({
              identifier: global.fetchUniqueCode(),
              idProducto: element.idProducto,
              idTipoProducto: element.idTipoProducto,
              codigo: element.codigoReferencia,
              nombre: element.nombre,
              numeroLote: element.numeroLote,
              nombreUnidadMedida: element.nombreUnidadMedida,
              idUnidadMedida: element.idUnidadMedida,
              flagAfecto: element.flagAfecto,
              flagGratuito: element.flagGratuito,
              flagISC: element.flagISC,
              isc: element.importeISC,
              porcentajeMargenComercial: element.porcentajeMargenComercial,
              precioPromedio: element.precioPromedio,
              precioUnitario: element.precioUnitario,
              precioUnitarioSinIGV: element.precioUnitarioSinIGV,
              valorUnitario: precioNuevo,
              cantidad: element.cantidad,
              porcentajeDescuento: 0,
              importeDescuento: 0,
              subTotal: element.subTotal,
              igv: element.igv,
              total: element.total,
              importado: false,
              idImpuesto: element.idImpuesto ?? 1,
              flagConversion: element.flagConversion,
              totalDetalle: (element.precioUnitarioSinIGV * element.cantidad),
            });

            productos.push({
              identifier: global.fetchUniqueCode(),
              idProducto: element.idProducto,
              idTipoProducto: element.idTipoProducto,
              nombre: element.nombre,
              numeroLote: element.numeroLote,
              cantidad: element.cantidad,
              idUnidadMedida: element.idUnidadMedida,
              porcentajeMargenComercial: element.porcentajeMargenComercial,
              precioPromedio: element.precioPromedio,
              precioUnitarioSinIGV: element.precioUnitarioSinIGV,
              precioUnitario: element.precioUnitario,
              valorUnitario: precioNuevo,
              idImpuesto: element.idImpuesto ?? 1,
              porcentajeDescuento: 0,
              importeDescuento: 0,
              total: element.total,
              flagAfecto: element.flagAfecto,
              flagISC: element.flagISC,
              flagOtrosImpuesto: element.flagOtrosImpuesto,
              flagGratuito: element.flagGratuito,
              flagChangeTotal: element.flagChangeTotal,
              subTotal: element.subTotal,
              importado: false,
              flagConversion: element.flagConversion,
              totalDetalle: (element.precioUnitarioSinIGV * element.cantidad),

            });

          }

        });


        listaCompraReferencia.push({
          identifier: global.fetchUniqueCode(),
          idReferencia: response.ordenCompra.id,
          idReferenciaOrigen: LOGISTICA_ORDEN_COMPRA,
          idTipoComprobante: response.ordenCompra.idTipoComprobante,
          serie: response.ordenCompra.serie,
          documento: response.ordenCompra.documento,
          flagInterno: true,
          importado: false
        });

        sumaTotalDetalle = response.ordenCompra.subTotal + sumaSubTotal;
        sumaImporteDescuento = response.ordenCompra.importeDescuento + sumaImporteDescuento;
        sumaSubTotal = response.ordenCompra.subTotal + sumaSubTotal;
        sumaIgv = response.ordenCompra.igv + sumaIgv;
        sumaIsc = response.ordenCompra.isc + sumaIsc;
        sumaTotal = response.ordenCompra.total + sumaTotal;

        contador++;

        if (contador == row.length) {
          listaCompraReferencia = listaCompraReferencia.filter(m => selected.filter(f => f === m.serie + '-' + m.documento).length);
          //totalMetodoPago = (totalMetodoPago - this.state.formValues.totalAnticipo);
          if (this.state.formValues.totalAnticipo > 0) {
            listaCompraReferencia = listaCompraReferencia.concat(this.state.importarAnticipo.listaCompraReferencia);
          }
          obj = {
            sumaTotalDetalle: sumaTotalDetalle + (totalMetodoPago / 1.18),
            sumaImporteDescuento: sumaImporteDescuento,
            sumaSubTotal: sumaSubTotal + (totalMetodoPago / 1.18),
            sumaIgv: sumaIgv + (totalMetodoPago - (totalMetodoPago / 1.18)),
            sumaIsc: sumaIsc,
            sumaTotal: sumaTotal + totalMetodoPago,
          }

          this.SelectCotizacion(response, listaCompraDetalle, productos, listaCompraReferencia, selected, obj);

        }
      })



    }



  };

  SelectCotizacion = async (response, listaCompraDetalle, productos, listaCompraReferencia, selected, obj) => {

    var listaMetodoPago = [];
    const almacenes = await almacenService.listarPorIdEstablecimiento(response.ordenCompra.idEstablecimiento);
    const listasPrecio = this.state.listasPrecio.filter(m => m.idEstablecimiento === response.ordenCompra.idEstablecimiento);
    var formValues = {
      ...this.state.formValues,
      almacenes: almacenes,
      listasPrecio: listasPrecio,
      idEstablecimiento: response.ordenCompra.idEstablecimiento,
      //idAlmacen: response.ordenCompra.idAlmacen,
      idMoneda: response.ordenCompra.idMoneda,
      idListaPrecio: response.ordenCompra.idListaPrecio,
      listaCompraDetalle: listaCompraDetalle,
      listaCompraReferencia: listaCompraReferencia,
      listaComprobanteMetodoPago: listaMetodoPago,
      isImportando: true,
      encargado: response.ordenCompra.encargado,
      idVehiculo: response.ordenCompra.idVehiculo,
      observacion: response.ordenCompra.observacion,
      //otroImpuesto: response.ordenCompra.otroImpuesto ? 1 : 2,
      idVendedor: response.ordenCompra.idVendedor,
      idProyecto: response.ordenCompra.idProyecto,


    };

    if ((formValues.idCliente === 0 || formValues.idCliente === undefined) &&
      response.ordenCompra.idCliente !== null && response.ordenCompra.idCliente !== undefined &&
      formValues.clientes.filter(m => m.id === response.ordenCompra.idCliente).length !== 0) {
      const direcciones = await establecimientoService.listarPorIdEntidad(response.ordenCompra.idEntidadCliente);
      formValues.documentoCliente = response.ordenCompra.numeroDocumentoCliente;
      formValues.idCliente = response.ordenCompra.idCliente;
      formValues.direcciones = direcciones;
      formValues.idEstablecimientoCliente = direcciones[0].id;
    }


    this.setState({
      almacenes: formValues.almacenes,
      listasPrecio: formValues.listasPrecio,
      direcciones: formValues.direcciones,
      formValues: formValues,
      importarCotizacionFormValues: {
        ...this.state.importarCotizacionFormValues,
        selectedRowKeys: selected
      }
    }, () => {

      this.state.onSetFieldsValue({
        //idCliente: formValues.idCliente !== 0 ? { key: formValues.idCliente} : undefined,
        idEstablecimientoCliente: formValues.idEstablecimientoCliente !== 0 ? { key: formValues.idEstablecimientoCliente } : undefined,
        documentoCliente: formValues.documentoCliente,
        idEstablecimiento: { key: response.ordenCompra.idEstablecimiento },
        //idAlmacen: { key: response.ordenCompra.idAlmacen },
        idListaPrecio: { key: response.ordenCompra.idListaPrecio },
        idMoneda: { key: response.ordenCompra.idMoneda },
        //otroImpuesto: { key: response.ordenCompra.otroImpuesto ? 1 : 2 },
        idProyecto: { key: response.ordenCompra.idProyecto },

        detalleProductos: productos,
        idTipoComprobanteImportado: response.ordenCompra.idTipoComprobante,
        sumaTotalDetalle: obj.sumaTotalDetalle,
        sumaImporteDescuento: obj.sumaImporteDescuento,
        sumaSubTotal: obj.sumaSubTotal,
        sumaIgv: obj.sumaIgv,
        sumaIsc: obj.sumaIsc,
        sumaTotal: obj.sumaTotal,
      });
    });
  }

  handleAgregarSerie = async (row, onCalculateDetail, setFieldsValueDetalle, getFieldValueDetalle) => {
    debugger;
    this.setState({
      setFieldsValueDetalle,
      getFieldValueDetalle
    }, async () => {
      this.setState({
        agregarSerieVisible: true,
        agregarSerieModal: {
          ...this.state.agregarSerieModal,
          idProducto: row.idProducto,
          codigoProducto: row.codigo,
          nombreProducto: row.nombre,
          serie: '',
          listaCompraDetalleSerie: row.listaCompraDetalleSerie,
          onCalculateDetail: onCalculateDetail,
          setFieldsValueDetalle: setFieldsValueDetalle,
          getFieldValueDetalle: getFieldValueDetalle
        }
      });

    });
  }

  handleAgregarSerieDetalle = async (form) => {

    debugger;
    var params = auth.user().parametros;
    var listaCompraDetalle = this.state.formValues.detalleProductos;
    var listaCompraDetalleSerie = [];

    /*VALIDAR EXISTE SERIE EN MOVIMIENTOS*/

    var result = await movimientoService.serieValidarExistencia({ idProducto: form.idProducto, serie: form.serie });

    if (result.flagExiste) {
      dialog.error("La serie ya ha sido registrado en una compra.");
      return;
    }


    listaCompraDetalle.forEach(compradetalle => {
      if (compradetalle.idProducto === form.idProducto) {

        if (compradetalle.listaCompraDetalleSerie.filter(m => m.serie === form.serie).length > 0) {
          dialog.error("La serie ya se encuentra agregada.");
        } else {
          compradetalle.listaCompraDetalleSerie.push({
            identifier: global.fetchUniqueCode(),
            idProducto: form.idProducto,
            serie: form.serie
          });
        }
        debugger;
        compradetalle.detalleSeries = compradetalle.listaCompraDetalleSerie.map(u => u.serie).join(', ');
        compradetalle.cantidad = compradetalle.listaCompraDetalleSerie.length;

        listaCompraDetalleSerie = compradetalle.listaCompraDetalleSerie;

        form.onCalculateDetail(compradetalle, "arrCantidad", compradetalle.cantidad, 3);
      }
    });

    this.setState({
      formValues: {
        ...this.state.formValues,
        listaCompraDetalle: listaCompraDetalle,
        detalleProductos: listaCompraDetalle
      },
      agregarSerieModal: {
        ...this.state.agregarSerieModal,
        listaCompraDetalleSerie: listaCompraDetalleSerie,
        serie: ''
      }
    });
  }

  handleRemoverSerieDetalle = (item, onCalculateDetail) => {
    debugger;
    var listaCompraDetalle = this.state.formValues.detalleProductos;
    var listaCompraDetalleSerie = [];

    listaCompraDetalle.forEach(compradetalle => {
      if (compradetalle.idProducto === item.idProducto) {

        compradetalle.listaCompraDetalleSerie = compradetalle.listaCompraDetalleSerie.filter(m => m.identifier !== item.identifier);
        compradetalle.detalleSeries = compradetalle.listaCompraDetalleSerie.map(u => u.serie).join(', ');
        compradetalle.cantidad = compradetalle.listaCompraDetalleSerie.length;

        listaCompraDetalleSerie = compradetalle.listaCompraDetalleSerie;

        onCalculateDetail(compradetalle, "arrCantidad", compradetalle.cantidad, 3);
      }
    });

    this.setState({
      formValues: {
        ...this.state.formValues,
        listaCompraDetalle: listaCompraDetalle,
        detalleProductos: listaCompraDetalle
      },
      agregarSerieModal: {
        ...this.state.agregarSerieModal,
        listaCompraDetalleSerie: listaCompraDetalleSerie,
        serie: ''
      }
    });
  };

  async componentDidMount() {
    this._isMounted = true;
    const empresa = await empresaService.obtenerPrincipal(0);

    var idUsuario = auth.user().id;
    const configuraciones = await configuracionService.obtenerPorModulo({ idUsuario: idUsuario, idModulo: LOGISTICA });

    this._initPagination(this.state.filter, compraService.paginacion);
    const proveedores = await proveedorService.listar();
    const tiposComprobante = await tipoComprobanteService.listar();
    const monedas = await monedaService.listar();
    const tiposCambioDiario = await tipoCambioDiarioService.listarPorFecha(
      global.fetchCurrentDateStr()
    );
    const listasPrecio = await listaPrecioService.listar();
    const establecimientos = await establecimientoService.principales();
    const vendedores = await vendedorService.listar();
    const detracciones = await detraccionService.listar();
    const formasPago = await formaPagoService.listar();
    const metodosPagos = await metodoPagoservice.listar();
    const cuentas = await cuentaService.listar();
    const banco = await bancoService.listar();
    const proyectos = await proyectoService.listar();

    const almacen = await almacenService.listarPorIdEstablecimiento(-1);
    const tipoAlmacen = await almacenService.listaTipoEstablecimiento('000001');

    const motivos = await motivoNotaCreditoService.listar();
    const clasificacion = await compraService.listarClasificacion();
    var clasificacion_filter = clasificacion.filter(m => m.codigo === 2);

    //const notifyExpi = await hubService.notifyExpiration({ userId: auth.user().userName, sessionId: auth.user().session });
    //const notifyStock = await hubService.NotifyStock({ userId: auth.user().userName, sessionId: auth.user().session });

    // var conceptos_filter = conceptos.filter(m => m.idTipoMovimiento === INGRESO.ID);
    if (this._isMounted) {
      this.setState({
        loadingSource: false,
        tiposCambioDiario: tiposCambioDiario ? tiposCambioDiario : [],
        monedas: monedas ? monedas : [],
        listasPrecio: listasPrecio ? listasPrecio : [],
        establecimientos: establecimientos ? establecimientos : [],
        vendedores: vendedores ? vendedores : [],
        tiposComprobante: tiposComprobante ? tiposComprobante : [],
        detracciones: detracciones ? detracciones : [],
        proveedores: proveedores ? proveedores : [],
        formasPago: formasPago ? formasPago : [],
        metodosPagos: metodosPagos ? metodosPagos : [],
        cuentas: cuentas ? cuentas : [],
        listaBanco: banco ? banco : [],
        listaCuentas: cuentas ? cuentas : [],
        TipoAlmacen: tipoAlmacen ? tipoAlmacen : [],
        almacenes: almacen ? almacen : [],
        motivos: motivos ? motivos : [],
        clasificacion: clasificacion_filter ? clasificacion_filter : [],
        clasificacionAll: clasificacion ? clasificacion : [],
        proyectos: proyectos ? proyectos : [],
        configuraciones: configuraciones ? configuraciones : [],
        company: empresa
      });
    }

  }
  componentWillUnmount() {
    this._isMounted = false;
  }
  render() {
    return (
      <div>
        <Header
          title={this.state.filter.tipoReporte == 1 ? "Registrar Compras" : "Compras Detallado"}
          onNew={this.handleNew}
          loadingNew={this.state.loadingSource || this.state.loadingNew}
          onSearch={() => this._handlePagination(this.state.filter)}
          onClearFilters={this.handleClearFilters}
        />

        <Filters
          filter={this.state.filter}
          proveedores={this.state.proveedoresAutoComplete}
          tiposComprobante={this.state.tiposComprobante}
          onSearchAutocomplete={this.handleSearchAutocomplete}
          onChangeAutocomplete={this.handleChangeAutocomplete}
          onClearAutocomplete={this.handleClearAutocomplete}
          onKeyUpSearch={this.handleKeyUpInput}
          onChange={this.handleChange}
          proyectos={this.state.proyectos}

        />
        {this.state.filter.tipoReporte == 1 ?
          <ResultList
            pagination={this.state.pagination}
            loadingEdit={this.state.loadingEdit || this.state.loadingSource}
            loadingVincular={this.state.loadingVincular}
            onExportExcel={this.handleExportExcel}
            onExportPdf={this.handleExportPdf}
            onChange={this._handleChangePagination}
            onEdit={this.handleEdit}
            onAnular={this.handleAnular}
            onAprobar={this.handleAprobar}
            onView={this.handleView}
            onVincular={this.handleVincular}
          /> :
          <DetalleIngreso
            pagination={this.state.pagination}
            loadingExcel={this.state.loadingExcel}
            loadingPdf={this.state.loadingPdf}
            onExportExcel={this.handleDetalleExportExcel}
            onExportPdf={this.handleDetalleExportPdf}
            onVer={this.handleVer}
            onImprimir={this.handleImprimir}
            onChange={this._handleChangePagination}
          />
        }

        <FormModal
          visible={this.state.visible}
          formValues={this.state.formValues}
          onBuscarProveedor={this.handleBuscarProveedor}
          onAgregarDetalle={this.handleAgregarDetalle}
          onAgregarItem={this.handleAgregarItem}
          onRemoverProducto={this.handleRemoverProducto}
          onRemoverReferencia={this.handleRemoverReferencia}
          onEditarNombreProducto={this.handleEditarNombreProducto}
          onChangeTab={this.handleChangeTab}
          onChange={this.handleChangeForm}
          onClose={() => this.setState({ visible: false })}
          onSave={this.handleSave}
          onScanerProduct={this.handleScaner}
          onImportarOrdenCompra={this.handleImportarOC}
          onImportarCompra={this.handleImportarCompra}
          onRemoverCuota={this.handleRemoverCuota}
          onAgregarSerie={this.handleAgregarSerie}
          onRemoverMetodoPago={this.handleRemoverMetodoPago}
          isPendiente={this.state.isPendiente}
          isPendienteSi={this.state.isPendienteSi}
          onChangePago={this.handlePago}
          onCalculateMetodoPago={this.onCalculateMetodoPago}
        />

        <ViewModal
          visible={this.state.viewVisible}
          formValues={this.state.viewFormValues}
          onClose={() => this.setState({ viewVisible: false })}
        />

        <BuscarProductoModal
          visible={this.state.searchProductVisible}
          formValues={this.state.searchProductFormValues}
          title={this.state.formValues.idTipo != 1 ? "Búsqueda de Producto" : "Búsqueda de Servicios"}
          onChange={this.handleChangeProductoModal}
          onSearch={this.handleChangeProductoModal}
          onChangeRow={this.handleSelectProduct}
          onCancel={() => this.setState({ searchProductVisible: false })}
        />
        <EditarNombreProductoModal
          visible={this.state.editarNombreProductoVisible}
          formValues={this.state.editarNombreProductoFormValues}
          onClose={() => this.setState({ editarNombreProductoVisible: false })}
          onSave={this.handleSaveEditarNombreProducto}
        />
        {/*        <ImportarOrdenCompraModal
          visible={this.state.importarOCVisible}
          formValues={this.state.importarOrdenCompraModal}
          onCancel={() => this.setState({ importarOCVisible: false })}
          onChangeRow={this.handleSelectRowOrdenCompra}
          onHandleOkImportarOrdenCompra={this.handleOkImportarOrdenCompra}
        />  */}

        <ImportarModalOC
          tittle="Búsqueda de Orden Compra"
          visible={this.state.importarOCVisible}
          formValues={this.state.importarCotizacionFormValues}
          onSelect={this.handleSelectCotizacion}
          onClose={() => this.setState({ importarOCVisible: false })}
        />

        <ImportarOrdenCompraModal
          visible={this.state.importarOSVisible}
          formValues={this.state.importarOrdenCompraModal}
          onCancel={() => this.setState({ importarOSVisible: false })}
          onChangeRow={this.handleSelectRowOrdenCompra}
          onHandleOkImportarOrdenCompra={this.handleOkImportarOrdenCompra}
        />



        <ImportarCompra
          visible={this.state.importarCompraVisible}
          formValues={this.state.importarCompraModal}
          onCancel={() => this.setState({ importarCompraVisible: false })}
          onChangeRow={this.handleSelectRowCompra}
          onHandleOkImportarCompra={this.handleOkImportarCompra}
        />

        <AgregarSerieModal
          visible={this.state.agregarSerieVisible}
          formValues={this.state.agregarSerieModal}
          onCancel={() => this.setState({ agregarSerieVisible: false })}
          onAgregarSerieDetalle={this.handleAgregarSerieDetalle}
          onRemove={this.handleRemoverSerieDetalle}
        />

        <Vincular
          visible={this.state.visibleVincular}
          tiposComprobante={this.state.tiposComprobante}
          listaComprobanteCuota={this.state.cuotasVinculo}
          onAgregarDetalle={this.handleAddCuotaVincular}
          onRemoverCuota={this.handleRemoverCuotaVincular}
          formasPago={this.state.formasPago}
          formValues={this.state.viewVincular}
          onClose={() => this.setState({ visibleVincular: false })}
          onSave={this.handleSaveVincular}
        />
      </div>
    );
  }
}